/**
 * Dummy data generator for testing
 * Based on real data from KML files
 *
 * Enable/disable by setting ENABLE_DUMMY_DATA to true/false
 */

const ENABLE_DUMMY_DATA = false

// Region data extracted from KML (Q-regiovlekken-2020-11-27a.kml)
const REGION_DATA = [
  { id: 1, name: 'Brabantse Wal', kmlId: 1, lat: 51.5, lng: 4.3, hexcolor: '#007E95' },
  { id: 2, name: 'Baronie van Breda', kmlId: 2, lat: 51.5, lng: 4.6, hexcolor: '#EA4F3D' },
  { id: 3, name: 'Land van Heusden en Altena', kmlId: 3, lat: 51.8, lng: 5.0, hexcolor: '#BCCF00' },
  { id: 4, name: 'Hart van het Groene Woud', kmlId: 4, lat: 51.5, lng: 5.5, hexcolor: '#27A737' },
  { id: 5, name: 'Ten Oosten van Tilburg', kmlId: 5, lat: 51.6, lng: 5.2, hexcolor: '#6C1C5A' },
  { id: 6, name: 'Ten Zuiden van Den Bosch', kmlId: 6, lat: 51.7, lng: 5.3, hexcolor: '#009E8F' },
  { id: 7, name: 'De Kempen', kmlId: 7, lat: 51.4, lng: 5.0, hexcolor: '#C61A27' },
  { id: 8, name: 'De Groote Heide', kmlId: 8, lat: 51.4, lng: 5.6, hexcolor: '#F59E33' },
  { id: 9, name: 'Maas en Peel', kmlId: 9, lat: 51.6, lng: 5.8, hexcolor: '#D05874' },
]

// Actual polygon coordinates extracted from KML file (Q-regiovlekken-2020-11-27a.kml)
// Each region can have multiple polygons (some regions are split into multiple areas)
const REGION_POLYGONS = {
  1: {
    id: 1,
    name: 'Brabantse Wal',
    hexcolor: '#007E95',
    polygons: [
      [
        [51.5009518448786, 4.22102082785137],
        [51.5081990016473, 4.2322693731407],
        [51.5118642854742, 4.24218215466854],
        [51.5119804296693, 4.2540909930419],
        [51.5121500947559, 4.27171620187716],
        [51.515510294279, 4.28116387814748],
        [51.522148277844, 4.29148701945935],
        [51.5278936422487, 4.30183446912339],
        [51.5309278113317, 4.3084353245807],
        [51.5309804760802, 4.3141540592354],
        [51.532829346101, 4.32126067107402],
        [51.5364482536762, 4.32689644586026],
        [51.537977606275, 4.33162813611992],
        [51.538059069089, 4.3406842660543],
        [51.5345559971862, 4.34791544775015],
        [51.5298339924659, 4.35183662957577],
        [51.524801980429, 4.35433423193783],
        [51.5194347675076, 4.35254999984767],
        [51.5167553731614, 4.3521344575854],
        [51.5137829577463, 4.35220211817551],
        [51.5075955868711, 4.35853635307251],
        [51.5034760469366, 4.36339325638933],
        [51.4987326795429, 4.36492898017795],
        [51.4927753071764, 4.36363404551999],
        [51.4868262735291, 4.36329165526563],
        [51.4833051641226, 4.36860865775144],
        [51.4774223684353, 4.37588180403089],
        [51.4727075966128, 4.38074704606698],
        [51.4673653955257, 4.3818171191309],
        [51.4605287641252, 4.38196804597473],
        [51.4518428510617, 4.3745464004854],
        [51.4488124211694, 4.36795254157482],
        [51.448724732146, 4.35796268222269],
        [51.4468781164803, 4.35086766497302],
        [51.4444493384203, 4.34521382017305],
        [51.4414471332277, 4.34195238885339],
        [51.4393151674291, 4.33629283947779],
        [51.4389404981828, 4.32773886514661],
        [51.4377039088845, 4.32253504182916],
        [51.4370877025761, 4.320171026819],
        [51.4376385885733, 4.31540124669435],
        [51.4393738489522, 4.31012766071997],
        [51.4387265412308, 4.30443455763492],
        [51.4338820549677, 4.29503664773571],
        [51.4287485546139, 4.28659889876003],
        [51.4268342123432, 4.27285335795033],
        [51.4282337395482, 4.26378287156897],
        [51.4307334374542, 4.24564768791524],
        [51.4582545042554, 4.23258430619607],
        [51.4944032410071, 4.22023611280965],
        [51.5009518448786, 4.22102082785137],
      ],
      [
        [51.4337655762953, 4.34736066482207],
        [51.4376551335411, 4.35012603415941],
        [51.438877865824, 4.35390379887143],
        [51.4389533731244, 4.36246467358552],
        [51.4369392520709, 4.37012080592666],
        [51.4340081677049, 4.37494268260938],
        [51.4289591282806, 4.37553039969324],
        [51.4247811881574, 4.37372091194941],
        [51.4205700508158, 4.36810843857959],
        [51.4204907773879, 4.35907559155551],
        [51.4239777234009, 4.34996163598211],
        [51.4286912319227, 4.34509845594802],
        [51.4337655762953, 4.34736066482207],
      ],
      [
        [51.5672083712933, 4.30948156919523],
        [51.5692978212874, 4.31038610381992],
        [51.5710856362217, 4.31082078322328],
        [51.5797318294151, 4.31347879517841],
        [51.5859738052092, 4.31333109891753],
        [51.5898159466822, 4.31085374649032],
        [51.593942053132, 4.30693723693662],
        [51.5975221040394, 4.308284075508],
        [51.5973299776117, 4.31974534204626],
        [51.5941470956869, 4.32936679854874],
        [51.5936300062328, 4.33797065400403],
        [51.5938249047786, 4.3599230131703],
        [51.5915138028362, 4.36761210842668],
        [51.5903787618085, 4.37384232690881],
        [51.5878022662628, 4.38535405663047],
        [51.5824804688746, 4.38881195071416],
        [51.5774069511488, 4.38653781045498],
        [51.5746538434257, 4.37753323257923],
        [51.568646996539, 4.37051097015856],
        [51.5634895884459, 4.35870136894018],
        [51.5613033935445, 4.34682636003658],
        [51.5594944513767, 4.34400602765818],
        [51.555897734723, 4.34075016873213],
        [51.5522235282565, 4.32891264873587],
        [51.5527050922309, 4.31650221976728],
        [51.5547331968283, 4.31073143433976],
        [51.5672083712933, 4.30948156919523],
      ],
    ],
  },
  2: {
    id: 2,
    name: 'Baronie van Breda',
    hexcolor: '#EA4F3D',
    polygons: [
      [
        [51.5071281234554, 4.57883694271731],
        [51.5126160861755, 4.58140755528941],
        [51.5174193278277, 4.58818414287137],
        [51.5215293995322, 4.59802415210901],
        [51.5242194277533, 4.60903405783689],
        [51.5281099574361, 4.62193146417279],
        [51.5300695239335, 4.63066861099822],
        [51.5341711491798, 4.63975260426818],
        [51.5375223632304, 4.6431298377698],
        [51.5437005103011, 4.64226582008668],
        [51.5489201093748, 4.64027289471869],
        [51.5520262134436, 4.64251078747823],
        [51.553489376855, 4.64820939404052],
        [51.5535682886177, 4.66079782682897],
        [51.555998231152, 4.66915255161476],
        [51.5596581150909, 4.68435696642425],
        [51.5611622474158, 4.69730703742627],
        [51.5595888453806, 4.71297470760249],
        [51.5593795358581, 4.71793800717517],
        [51.561305974416, 4.72210688099529],
        [51.5620410521079, 4.72591186938032],
        [51.5592088392101, 4.72976862050224],
        [51.5556523829314, 4.731727702357],
        [51.5525757782779, 4.73444256371609],
        [51.5502167844565, 4.73790973896578],
        [51.5471463581782, 4.74176811468109],
        [51.542398534473, 4.74336119147251],
        [51.5378905940573, 4.74533191475982],
        [51.5355354355742, 4.74956004744725],
        [51.5331904418461, 4.75569425854624],
        [51.5289262573464, 4.75880386605508],
        [51.5234462950139, 4.75697335561164],
        [51.5177160937341, 4.75285954776926],
        [51.5141260614825, 4.74871672750677],
        [51.5136106316784, 4.74148176881605],
        [51.515247824119, 4.73650315573238],
        [51.5194749719511, 4.72691222178186],
        [51.5251463380586, 4.7183294219427],
        [51.5309288084825, 4.71061804778272],
        [51.5321963833057, 4.70575455921861],
        [51.5297351545902, 4.69168317403611],
        [51.5273287057946, 4.68493490752683],
        [51.52443469691, 4.6783075429729],
        [51.522011260112, 4.67091112968503],
        [51.5188868965243, 4.66562333804681],
        [51.5167289204831, 4.66279860368791],
        [51.5129216082442, 4.66247808425865],
        [51.5085233177075, 4.66273872993856],
        [51.5063593357697, 4.65896209334118],
        [51.5035855964692, 4.65473653265212],
        [51.4990336491576, 4.64947512924169],
        [51.4942193557323, 4.64040896559654],
        [51.4901128514439, 4.63057100364453],
        [51.4880980578038, 4.61346135961617],
        [51.4868096374613, 4.59862627188978],
        [51.4888930001007, 4.59020891051617],
        [51.4926561394703, 4.58404702881706],
        [51.498331948432, 4.5793742824847],
        [51.5071281234554, 4.57883694271731],
      ],
      [
        [51.5033562979378, 4.69513518834411],
        [51.5038386876615, 4.69627111325214],
        [51.5038678868455, 4.7012248140313],
        [51.5003252610378, 4.70546986994153],
        [51.4981760535602, 4.70397791254127],
        [51.4974155388847, 4.69598762017764],
        [51.5000133778819, 4.69289970486954],
        [51.5033562979378, 4.69513518834411],
      ],
      [
        [51.553469841286, 4.76762043030653],
        [51.5568394137689, 4.77520507146085],
        [51.5568632918475, 4.77978311149561],
        [51.5566609594186, 4.78665332608804],
        [51.5547838253834, 4.79163780289476],
        [51.5512494806923, 4.79816933806639],
        [51.547208566636, 4.79860317338445],
        [51.5429279156203, 4.798658620553],
        [51.5391036254125, 4.79489434201443],
        [51.5373882565106, 4.78500117546879],
        [51.5375964537463, 4.77927789367989],
        [51.5394489751642, 4.7697185131598],
        [51.54251627253, 4.76509991421851],
        [51.5470326839667, 4.76465662882339],
        [51.553469841286, 4.76762043030653],
      ],
    ],
  },
  3: {
    id: 3,
    name: 'Land van Heusden en Altena',
    hexcolor: '#BCCF00',
    polygons: [
      [
        [51.8210873516987, 4.90117920449997],
        [51.8247485592688, 4.91249999397129],
        [51.8266879324758, 4.92169098598596],
        [51.8267252890118, 4.9312090670173],
        [51.8263731816007, 4.93858170344638],
        [51.8252848067004, 4.95271624470225],
        [51.8241759237871, 4.96163078527921],
        [51.8223020907275, 4.96963090340017],
        [51.8217786125489, 4.98314431256068],
        [51.820298233738, 4.99543767787974],
        [51.8187965584915, 5.00159056751581],
        [51.8161580065219, 5.00928748214024],
        [51.8136896762536, 5.01084295386938],
        [51.8102710490964, 5.01271308625666],
        [51.8061039842074, 5.01857888689338],
        [51.8027098917279, 5.02842685206268],
        [51.8000805283666, 5.03980173498073],
        [51.7972465395508, 5.04657413991382],
        [51.7945954014951, 5.05088972604662],
        [51.7909893644078, 5.05398462098527],
        [51.7822455677186, 5.05680985366028],
        [51.7742566898548, 5.05748169305068],
        [51.7658855734101, 5.05754281391646],
        [51.7597948954522, 5.05666749815916],
        [51.7538840074978, 5.05211249977155],
        [51.7513858830416, 5.0435481059487],
        [51.750402690601, 5.03282716025213],
        [51.7524529736943, 5.01901675462104],
        [51.756237631464, 5.01254801264925],
        [51.760411367679, 5.00883425325846],
        [51.7689355518867, 4.99741667205679],
        [51.7732876870687, 4.99032539963819],
        [51.7780050273754, 4.97893548041836],
        [51.781213445031, 4.97154477899768],
        [51.7832654437756, 4.9601761015631],
        [51.7841736898892, 4.9485107356529],
        [51.7835540576455, 4.93563312591476],
        [51.7829402834921, 4.92459629574829],
        [51.7802589327242, 4.91008777036531],
        [51.7792099028309, 4.89790656708003],
        [51.7792469000391, 4.8897396184916],
        [51.7801453901096, 4.88294329084722],
        [51.7826958776799, 4.87877368827014],
        [51.7866811085727, 4.8764279685285],
        [51.7944535099808, 4.87541948697094],
        [51.8028056736658, 4.87647553794945],
        [51.8087470985489, 4.88101213635708],
        [51.8140437960523, 4.88498154661453],
        [51.8173447035647, 4.88943441957656],
        [51.8210873516987, 4.90117920449997],
      ],
      [
        [51.7246945758095, 4.96808193179451],
        [51.7252762457843, 4.97114010935474],
        [51.7252913907522, 4.97542896877022],
        [51.7232146684869, 4.98004302680713],
        [51.7203661939472, 4.98160029511547],
        [51.7205340094596, 4.97516597048943],
        [51.7222267657939, 4.96963649057241],
        [51.7246945758095, 4.96808193179451],
      ],
      [
        [51.7175193318042, 5.11578666441496],
        [51.7241922647605, 5.12187356557946],
        [51.7257340700087, 5.13074890042635],
        [51.7255687003789, 5.14239139533661],
        [51.7219658676037, 5.14823121099925],
        [51.7168351878665, 5.15132129187922],
        [51.7122776151258, 5.15563278711717],
        [51.709227443368, 5.15258594020156],
        [51.7074989409244, 5.14463281388599],
        [51.7044228487457, 5.12964484367079],
        [51.7087704479245, 5.11706412740666],
        [51.7175193318042, 5.11578666441496],
      ],
    ],
  },
  4: {
    id: 4,
    name: 'Hart van het Groene Woud',
    hexcolor: '#27A737',
    polygons: [
      [
        [51.5688070287783, 5.61862611512199],
        [51.5638348623797, 5.63111660673901],
        [51.5546797004264, 5.64174951681629],
        [51.5445933763612, 5.64291350385794],
        [51.5345163516423, 5.63980607985728],
        [51.5299580223348, 5.63612027956987],
        [51.5274833651825, 5.63671675888122],
        [51.5251850638347, 5.64371925529214],
        [51.5221127894973, 5.65620628215159],
        [51.5182737231584, 5.67051663184265],
        [51.5129269941454, 5.6784113057546],
        [51.5066439088648, 5.68020033748272],
        [51.4992344868343, 5.67588493998834],
        [51.4935482760327, 5.6670098265481],
        [51.4899730471813, 5.64992074105294],
        [51.4881159169462, 5.62888179564952],
        [51.4875721480253, 5.61546977598522],
        [51.4856859428561, 5.60692758142261],
        [51.483425698517, 5.59442293573337],
        [51.476417644381, 5.57580565072391],
        [51.4733925646719, 5.56360680313275],
        [51.4715060443303, 5.55263227066856],
        [51.472661838659, 5.54227828877519],
        [51.4738856086307, 5.53243790889187],
        [51.472273451247, 5.52831998688706],
        [51.4711390200676, 5.52229978251015],
        [51.4708590069583, 5.51757702571037],
        [51.4713873253345, 5.5129327223413],
        [51.4727227114427, 5.50958523527107],
        [51.4751982315219, 5.50753538210059],
        [51.4775772641306, 5.50677996717609],
        [51.4800493068265, 5.50808145343658],
        [51.4820231717334, 5.51174412666746],
        [51.4821306186562, 5.51875203951282],
        [51.4861917253886, 5.52525883435988],
        [51.4911344581652, 5.52862638689408],
        [51.4964642934533, 5.52650929267966],
        [51.4983722607581, 5.52194277396404],
        [51.500472336128, 5.51554739143097],
        [51.5028325220545, 5.51300069851723],
        [51.504641153857, 5.51191962065813],
        [51.5061512569887, 5.51199998646088],
        [51.5071607402074, 5.51318418355426],
        [51.5075116010551, 5.51587216847628],
        [51.5082661041992, 5.5216672323792],
        [51.5092057456635, 5.53142672474402],
        [51.5076755795913, 5.53782449322268],
        [51.5042412356861, 5.54512984318064],
        [51.5042349551865, 5.54970278140992],
        [51.5053730876857, 5.55214582535196],
        [51.5101274016756, 5.55368760510426],
        [51.5129719752241, 5.560101406125],
        [51.5112471543864, 5.56832744197218],
        [51.5078138441872, 5.57380174189342],
        [51.5062793340043, 5.58141738812103],
        [51.5077962907922, 5.58447275330561],
        [51.5108336641494, 5.5884497518198],
        [51.5152048509322, 5.59121355614417],
        [51.5197710598476, 5.59123406387496],
        [51.5256754189306, 5.58760049133126],
        [51.5304339722831, 5.58640133110233],
        [51.5365243212096, 5.58520772856139],
        [51.5405238635941, 5.58278431149959],
        [51.544907884798, 5.57792100739916],
        [51.5481382640208, 5.58037585304289],
        [51.5509818809401, 5.58649151698576],
        [51.5540191733881, 5.59047243543339],
        [51.5595366592791, 5.59049715388196],
        [51.5644933221979, 5.58471925797843],
        [51.5740036298224, 5.58628734003968],
        [51.5739882021752, 5.59514192095024],
        [51.5693955892944, 5.60947005707865],
        [51.5688070287783, 5.61862611512199],
      ],
      [
        [51.4961332825813, 5.3138743799522],
        [51.4978510767316, 5.32316865159181],
        [51.4966213450397, 5.33749656716847],
        [51.4951040910153, 5.35060472004757],
        [51.4932037691037, 5.35883556083321],
        [51.4890203356172, 5.37087623537643],
        [51.4846453278724, 5.38123868569606],
        [51.4782712272158, 5.39814976910758],
        [51.4714200313961, 5.41048616752673],
        [51.4663766334172, 5.41703268481063],
        [51.4613340817445, 5.41946597336643],
        [51.4568633343032, 5.41809233139529],
        [51.4538206931974, 5.41169521064015],
        [51.4536322696648, 5.40042769312901],
        [51.4549648363183, 5.3894648735896],
        [51.4569623170671, 5.37895810845541],
        [51.4608602617606, 5.36205361114798],
        [51.4649471206666, 5.34834434945282],
        [51.4678912796896, 5.33570011134571],
        [51.4716904054179, 5.32335768066083],
        [51.4751079022353, 5.31131849426161],
        [51.4797610747769, 5.29957981544864],
        [51.4858475419091, 5.29713019428392],
        [51.4933675611626, 5.3035159408272],
        [51.4961332825813, 5.3138743799522],
      ],
      [
        [51.6075400300361, 5.38770737004984],
        [51.6065881506684, 5.39878359301724],
        [51.6046842188385, 5.40833117934211],
        [51.6013527685804, 5.41711320330147],
        [51.5961193939535, 5.42169194636016],
        [51.5873171465931, 5.43008431749689],
        [51.5787527760447, 5.43694688354069],
        [51.571376552956, 5.44495327567826],
        [51.5642371682871, 5.45372057701978],
        [51.5594738590592, 5.46477832858279],
        [51.5547166182273, 5.4659146942112],
        [51.5480619840485, 5.45903708988064],
        [51.5428336723048, 5.45254494913696],
        [51.5333233819266, 5.4475740355362],
        [51.5283337885322, 5.43765407087663],
        [51.5250097435434, 5.42278147986025],
        [51.5242992100459, 5.41134349340219],
        [51.5212095058378, 5.3979990831767],
        [51.5176421552862, 5.37627029372625],
        [51.5133590785169, 5.36178738599794],
        [51.5097857418476, 5.3419708226802],
        [51.5104931150033, 5.32824937400005],
        [51.5138125169583, 5.31071173378898],
        [51.5202265964687, 5.30040819839812],
        [51.5271147761219, 5.2893381993808],
        [51.5337725649363, 5.28779857651793],
        [51.5451858142263, 5.28510368275047],
        [51.5549382346585, 5.28698931890912],
        [51.5616023615822, 5.29307961088636],
        [51.5620917887544, 5.31215684969245],
        [51.5609066463199, 5.31864523952605],
        [51.5637645477124, 5.32589093587907],
        [51.5685288854129, 5.34343899388128],
        [51.572099069165, 5.35183184301316],
        [51.5766192999142, 5.35755364183459],
        [51.5823259273294, 5.35335084901509],
        [51.5946214520995, 5.34571806253122],
        [51.6016576448256, 5.33708076340392],
        [51.606840171077, 5.33256814553887],
        [51.6084571515984, 5.33210785712237],
        [51.611216357482, 5.33309765787088],
        [51.6127392879034, 5.33500580148154],
        [51.6133105996972, 5.33622753270177],
        [51.6140730441756, 5.33958829863009],
        [51.6163098636, 5.34287133941948],
        [51.6198295511115, 5.34263867955855],
        [51.6237305219583, 5.34446886000127],
        [51.6260615934271, 5.34561298054142],
        [51.6268237176417, 5.34882200599071],
        [51.6281087785308, 5.35141934241163],
        [51.6283945984607, 5.35287118518925],
        [51.6262551303881, 5.35623532179528],
        [51.6241631475443, 5.359675529444],
        [51.6225465008419, 5.36212177700644],
        [51.620851189281, 5.36396709811578],
        [51.6189799410571, 5.36609699110696],
        [51.6166496670779, 5.36839021143914],
        [51.6135583781269, 5.37114186804151],
        [51.6112755236193, 5.37305256188766],
        [51.6089453715813, 5.37832431568169],
        [51.6075400300361, 5.38770737004984],
      ],
      [
        [51.6615140095452, 5.43933250505079],
        [51.6605686042769, 5.44899434179336],
        [51.6578236263931, 5.45825926899956],
        [51.6551371563863, 5.46431144806613],
        [51.650280782091, 5.47127645596087],
        [51.6469088522893, 5.47714199556234],
        [51.6435156635717, 5.48620626018486],
        [51.6413044429586, 5.49881508042329],
        [51.6402395967832, 5.5018664593083],
        [51.6385645453346, 5.50387259070455],
        [51.6366028962721, 5.50348533960496],
        [51.6348811335256, 5.50099675751725],
        [51.6345872457188, 5.49746089484689],
        [51.6348918219578, 5.48943589801069],
        [51.6353355779881, 5.4821334075228],
        [51.6357062855208, 5.47703412934213],
        [51.6374974000745, 5.46676606408927],
        [51.6398632741729, 5.45650740234187],
        [51.6441510641174, 5.44351727451752],
        [51.6501047552327, 5.42288016463585],
        [51.6583266644134, 5.41144622425027],
        [51.6637020183731, 5.40093213473238],
        [51.6681261536773, 5.39336081761553],
        [51.6709801208122, 5.39083683211911],
        [51.6734534541276, 5.3911239172204],
        [51.6741361938819, 5.39408552223545],
        [51.6739763441172, 5.39657470015112],
        [51.6714952395825, 5.40294443224259],
        [51.6687544907883, 5.409003668554],
        [51.6663158254982, 5.41378302339376],
        [51.6632234302074, 5.41674492777117],
        [51.6614389247718, 5.41989857226437],
        [51.6611998466985, 5.42410479712073],
        [51.6615140095452, 5.43933250505079],
      ],
    ],
  },
  5: {
    id: 5,
    name: 'Ten Oosten van Tilburg',
    hexcolor: '#6C1C5A',
    polygons: [
      [
        [51.6058047635327, 5.25861407697701],
        [51.600814622522, 5.26244711698882],
        [51.5939165405779, 5.26132056438416],
        [51.5886729038391, 5.25102679657142],
        [51.5793853724706, 5.24074844220987],
        [51.5691501903709, 5.23391218130177],
        [51.5579414251238, 5.21182120137605],
        [51.5522116597196, 5.19772844763868],
        [51.5498162919394, 5.18743893929579],
        [51.5431486766255, 5.18250994672069],
        [51.53434587309, 5.18064290404131],
        [51.5291021342703, 5.17418480583389],
        [51.5247977174155, 5.16162361598186],
        [51.5218966516921, 5.13838304437526],
        [51.5285316231918, 5.12728948932462],
        [51.5342186513275, 5.1181050018823],
        [51.5437288952824, 5.11690446732314],
        [51.5532452892481, 5.11837383587539],
        [51.5594390919539, 5.12291572222834],
        [51.5680049698865, 5.12477396853485],
        [51.5760787909989, 5.11938373716417],
        [51.5850846438162, 5.10596901345307],
        [51.5969599012504, 5.09940380876424],
        [51.608613107532, 5.0993298907749],
        [51.6290777604153, 5.10416767404869],
        [51.6364764531941, 5.11520508096259],
        [51.6391295012948, 5.13162441797825],
        [51.6391825950026, 5.15723255268312],
        [51.6382713885905, 5.17864079330716],
        [51.6326187522593, 5.19324862231655],
        [51.625810526745, 5.20376148559816],
        [51.6210186232248, 5.20908242692197],
        [51.6181104821019, 5.21158868245131],
        [51.6078998834365, 5.21347030265657],
        [51.6028019149593, 5.21493511415848],
        [51.599062246598, 5.22217521002132],
        [51.5993786109656, 5.23421731781923],
        [51.6055415002166, 5.2372266936477],
        [51.610075140597, 5.24943472559048],
        [51.6058047635327, 5.25861407697701],
      ],
    ],
  },
  6: {
    id: 6,
    name: 'Ten Zuiden van Den Bosch',
    hexcolor: '#009E8F',
    polygons: [
      [
        [51.6426078086323, 5.21264054060344],
        [51.6466646213837, 5.22218186616538],
        [51.6495310411665, 5.23134667897667],
        [51.6526388213823, 5.24395282158217],
        [51.6564673829148, 5.26458817974726],
        [51.6569537364081, 5.27529306504973],
        [51.6605317743418, 5.28713846245543],
        [51.6667234870025, 5.29745085956611],
        [51.6729173058275, 5.31235606025094],
        [51.6731624984503, 5.32497818891127],
        [51.6726906609497, 5.33262877564555],
        [51.6693641585601, 5.33951721370468],
        [51.661755071439, 5.34258443708679],
        [51.6577129518161, 5.34488262804906],
        [51.6532048870369, 5.34786901691802],
        [51.6489255385502, 5.35246027248447],
        [51.6450461930555, 5.35535572618902],
        [51.6410511664385, 5.35681099328335],
        [51.6365295142294, 5.35802463744055],
        [51.6338182930359, 5.35783528913264],
        [51.6326766596846, 5.35749208169291],
        [51.6314395162972, 5.35569678957031],
        [51.6297980688479, 5.3539783180586],
        [51.6290845801232, 5.35390241279896],
        [51.6282082997046, 5.35024233016324],
        [51.6270376071329, 5.3483632917435],
        [51.626151851858, 5.34529193059094],
        [51.620500105951, 5.34236294208972],
        [51.6165047565467, 5.3425502503918],
        [51.6142773973241, 5.33916024022882],
        [51.6135906658531, 5.33494370466726],
        [51.6107927424934, 5.33247172332459],
        [51.6083950580755, 5.33155791786112],
        [51.606911217318, 5.33192639763546],
        [51.6057131458218, 5.33311948122641],
        [51.6049111838074, 5.33232819077296],
        [51.6063347026507, 5.32545160455158],
        [51.609659261575, 5.31958865668367],
        [51.6117571702216, 5.31597157691139],
        [51.6124291587131, 5.3111518401766],
        [51.6106268805737, 5.30778191213491],
        [51.6084585467632, 5.29947577317056],
        [51.6073118526649, 5.2881537839814],
        [51.6015324406581, 5.28322841977222],
        [51.5941780826613, 5.28575728179485],
        [51.5884700017902, 5.28538823727862],
        [51.587513941158, 5.28004547462726],
        [51.5906013566243, 5.27545653464669],
        [51.5967802863921, 5.27085905194087],
        [51.6020417661395, 5.26684747518868],
        [51.6048173228751, 5.26732190682269],
        [51.6075198243569, 5.26972385426923],
        [51.609991323035, 5.26622410015325],
        [51.6150840073882, 5.25922302427499],
        [51.621818769534, 5.24582940608986],
        [51.626158678474, 5.2376216325344],
        [51.6258417780739, 5.22849175103337],
        [51.6255900713128, 5.21855803168155],
        [51.6264336661217, 5.21117435469197],
        [51.6302294595191, 5.20504539601114],
        [51.636177361241, 5.20655026267236],
        [51.6426078086323, 5.21264054060344],
      ],
      [
        [51.7111957272543, 5.49895741467285],
        [51.7168430355369, 5.49992857393853],
        [51.7204072956311, 5.50304854682507],
        [51.7220357308151, 5.50951441414097],
        [51.7174220886713, 5.51500575197756],
        [51.711771493184, 5.51714316420812],
        [51.7080534137259, 5.51904644735269],
        [51.7034426537683, 5.52166444450101],
        [51.6991302259002, 5.52332601130099],
        [51.6937758939312, 5.5261799455699],
        [51.6880794286719, 5.52583696883318],
        [51.6830878950518, 5.52352614480166],
        [51.6830974033848, 5.51510929659095],
        [51.6871448823683, 5.51091193978898],
        [51.6923133513905, 5.50441147536106],
        [51.6993005205827, 5.50323360169454],
        [51.7046545223266, 5.50013737283346],
        [51.7111957272543, 5.49895741467285],
      ],
      [
        [51.715961003461, 5.35356085074807],
        [51.7158132459515, 5.36617518305471],
        [51.7167185223583, 5.37442269126857],
        [51.7195539365204, 5.38273141336908],
        [51.7228834129054, 5.39153829361564],
        [51.728352470843, 5.40149600570222],
        [51.7328703310478, 5.40647653298525],
        [51.7366072543691, 5.40912221497164],
        [51.7385651135148, 5.41397723958898],
        [51.7393166973467, 5.42101620291519],
        [51.7372047179079, 5.42853819285966],
        [51.7333187567024, 5.43404771074586],
        [51.7246967061438, 5.43216613983529],
        [51.720327181295, 5.43143396061031],
        [51.7170141383549, 5.42585119021398],
        [51.713550808139, 5.4178434371441],
        [51.7096362539871, 5.40110495357847],
        [51.7058981874718, 5.39009183976086],
        [51.7023304390336, 5.37645621621845],
        [51.7003960201532, 5.36234345520316],
        [51.7020967523142, 5.34896346987151],
        [51.703749904733, 5.33732128540094],
        [51.7073611584371, 5.32640319918789],
        [51.7103728794394, 5.32276087898508],
        [51.7162471795622, 5.31862860491624],
        [51.7209223725941, 5.3258997892249],
        [51.7179167072107, 5.34385570191239],
        [51.715961003461, 5.35356085074807],
      ],
    ],
  },
  7: {
    id: 7,
    name: 'De Kempen',
    hexcolor: '#C61A27',
    polygons: [
      [
        [51.4978763436375, 4.97124267511175],
        [51.5093528113954, 4.98866955542833],
        [51.5184334662889, 5.00155086135965],
        [51.522528158536, 5.01752805984401],
        [51.5252029325691, 5.03656923356532],
        [51.5254996311293, 5.05677375276351],
        [51.5255365963761, 5.07011760312239],
        [51.5277114414394, 5.08306590983717],
        [51.531773037858, 5.09028368040942],
        [51.5294082574809, 5.0956372174655],
        [51.5237024300917, 5.09643628589426],
        [51.5175359240404, 5.10333717504735],
        [51.5108951653865, 5.11100135009364],
        [51.5085320740104, 5.11749468696355],
        [51.5085562164959, 5.12816582843446],
        [51.510250584921, 5.14187691131293],
        [51.5121841785041, 5.15711238144654],
        [51.5105463274446, 5.17122260205314],
        [51.5077049220043, 5.1780960585804],
        [51.5058183397622, 5.18725097410656],
        [51.5051257067835, 5.19982991274405],
        [51.5056127377671, 5.20706865112633],
        [51.5084752942742, 5.21277405781055],
        [51.5120488329859, 5.21695296405883],
        [51.5156167447745, 5.21732079243741],
        [51.5191841011609, 5.21730747490631],
        [51.5201408734771, 5.22111603661921],
        [51.5201467549606, 5.22530936263785],
        [51.5194410610102, 5.23102998491916],
        [51.5187360652735, 5.23751282955798],
        [51.5189906512714, 5.25123532012772],
        [51.5149635842757, 5.26573179687128],
        [51.509503497497, 5.27565558252451],
        [51.5021362511581, 5.28138955523653],
        [51.4954795448192, 5.28407205862351],
        [51.4892610145905, 5.28359195695222],
        [51.4867876367342, 5.28359757981662],
        [51.480223128832, 5.28300309413847],
        [51.4743234262581, 5.28118859772307],
        [51.4697871325798, 5.2761335549882],
        [51.4636011173044, 5.27348344508561],
        [51.4507585551611, 5.27351546156594],
        [51.4424397283637, 5.27886406717315],
        [51.4336486145483, 5.28839716579271],
        [51.427468300746, 5.29221491679852],
        [51.4217589192629, 5.2903248422207],
        [51.4172343493346, 5.2834880988389],
        [51.4179389960408, 5.2739775440512],
        [51.4210215233523, 5.26484068498837],
        [51.4219620441765, 5.2549479758611],
        [51.4193398096047, 5.24963039268323],
        [51.4136274511432, 5.24584438211447],
        [51.4029262113077, 5.24663797417338],
        [51.3957928031739, 5.2478004479249],
        [51.3860423911386, 5.24821029010741],
        [51.3774833444581, 5.25051644868189],
        [51.367960204736, 5.24218619994359],
        [51.3669884961176, 5.22661198964616],
        [51.3674346868076, 5.20647371716038],
        [51.3669325759189, 5.19013854890087],
        [51.3626284880281, 5.17686067179411],
        [51.3604669444236, 5.16547421082027],
        [51.3547525815102, 5.16208343399471],
        [51.3506961475745, 5.15526702419985],
        [51.3478142411354, 5.14160973252491],
        [51.3458870804349, 5.13022730085441],
        [51.3508695650816, 5.12488207771403],
        [51.3563221973167, 5.11725385437057],
        [51.3601247501475, 5.11609175786216],
        [51.3643903983313, 5.10960791674396],
        [51.3724590210084, 5.10233925027249],
        [51.3783733182648, 5.08976136525398],
        [51.3888008535649, 5.07562909756361],
        [51.3928448715879, 5.07598164827505],
        [51.3961834825405, 5.0793804955748],
        [51.4009538821776, 5.08467138213558],
        [51.4114356766963, 5.09144739094373],
        [51.4192962876138, 5.09634125672656],
        [51.4254984196518, 5.10391016567469],
        [51.4293072831377, 5.10540832511176],
        [51.4487778076493, 5.09272758510396],
        [51.4658696941567, 5.08043277649569],
        [51.4682348112428, 5.07546670422897],
        [51.4679489145998, 5.0579528659594],
        [51.4700598713218, 5.0476561141343],
        [51.474792781193, 5.03962327602326],
        [51.4781131770594, 5.03655102264949],
        [51.4828696096349, 5.03651439149918],
        [51.4814265468279, 5.0311930256807],
        [51.4797442411838, 5.0254930168799],
        [51.4749723737754, 5.02058002972609],
        [51.4697173642948, 5.01338724829062],
        [51.4658950359543, 5.00808794958626],
        [51.468241949788, 4.99854887277988],
        [51.474170888767, 4.99354746495197],
        [51.4805778487697, 4.98930233562853],
        [51.4860162126073, 4.9801124632012],
        [51.4912187415799, 4.97168449376967],
        [51.4978763436375, 4.97124267511175],
      ],
      [
        [51.5633814108112, 5.00116929698943],
        [51.564141840195, 5.01566308859267],
        [51.5606173797038, 5.02942792247096],
        [51.5537310507274, 5.03291562745386],
        [51.547288895964, 5.0260998647727],
        [51.5441685993712, 5.01697063367053],
        [51.5471932079104, 4.99634805501012],
        [51.5533611192438, 4.99171705299858],
        [51.5600239261832, 4.99280370136359],
        [51.5633814108112, 5.00116929698943],
      ],
    ],
  },
  8: {
    id: 8,
    name: 'De Groote Heide',
    hexcolor: '#F59E33',
    polygons: [
      [
        [51.4009235641244, 5.65305749258404],
        [51.3752108666931, 5.66476375675072],
        [51.3586271640998, 5.67742639949698],
        [51.3431788809199, 5.69191013906803],
        [51.332115521572, 5.70246642568161],
        [51.3235363998026, 5.7087840885451],
        [51.3195417892447, 5.70845234556132],
        [51.3133558435608, 5.67288860297234],
        [51.2814764428466, 5.63598050045012],
        [51.284280578648, 5.62171520194884],
        [51.288972716961, 5.60596093218842],
        [51.2939465226796, 5.59111507658049],
        [51.2975768364747, 5.58217842428541],
        [51.3022553186385, 5.57172703645933],
        [51.3063674727208, 5.55762882388697],
        [51.3119171490198, 5.53412198581504],
        [51.3201042740047, 5.51595103754257],
        [51.3281179682021, 5.49350068699617],
        [51.3385973579492, 5.47560337437065],
        [51.350211114301, 5.46468782082766],
        [51.3610589666014, 5.4601476539764],
        [51.3726662254488, 5.45803834870797],
        [51.3871243799379, 5.46079757052493],
        [51.4002498254564, 5.46477298181725],
        [51.4051943316459, 5.46812762411399],
        [51.4112773735586, 5.47544024861239],
        [51.4173571589568, 5.48610192729406],
        [51.4257057262316, 5.5101628036124],
        [51.4294883731324, 5.5299566662743],
        [51.4309828317638, 5.55096314871154],
        [51.4303787099229, 5.57317998330539],
        [51.4284173055063, 5.60695560875054],
        [51.4240098067009, 5.62306372233286],
        [51.4135038311419, 5.64278610562353],
        [51.4009235641244, 5.65305749258404],
      ],
      [
        [51.405720443297, 5.77446403226403],
        [51.4179474581804, 5.75904917472319],
        [51.4291648658338, 5.76157563809485],
        [51.4369595432579, 5.76346619845303],
        [51.4428856789034, 5.75468594578103],
        [51.4471118683858, 5.74162725163024],
        [51.4495861427838, 5.74134201152884],
        [51.4512873079874, 5.74500938244902],
        [51.4479885590244, 5.76538426943116],
        [51.442789913981, 5.78391286787224],
        [51.4360877961517, 5.79633533566737],
        [51.4234786788548, 5.81082980257207],
        [51.4149160203667, 5.81105448750001],
        [51.4075114120068, 5.80672656110249],
        [51.4025897015623, 5.7996849677448],
        [51.4030199378139, 5.78539192866454],
        [51.405720443297, 5.77446403226403],
      ],
    ],
  },
  9: {
    id: 9,
    name: 'Maas en Peel',
    hexcolor: '#D05874',
    polygons: [
      [
        [51.6858049160627, 5.81061862974191],
        [51.6872888379946, 5.79456228859554],
        [51.6902108203267, 5.77449953983737],
        [51.695631834727, 5.75273239509172],
        [51.7149910052212, 5.72072893867258],
        [51.7285818918479, 5.70819120341613],
        [51.7393145877536, 5.69677560267063],
        [51.7464656318717, 5.69050310023226],
        [51.7532797353358, 5.67617958522965],
        [51.7615026143244, 5.66875885236969],
        [51.7697182572145, 5.66421028290422],
        [51.7793471056638, 5.66541963911499],
        [51.7843218580978, 5.67350268163142],
        [51.7871585888627, 5.68042314206994],
        [51.7878560383983, 5.6867550200428],
        [51.7871187113972, 5.6959533797327],
        [51.7788987769484, 5.70164809109602],
        [51.7742410736472, 5.70909113624628],
        [51.7742040034146, 5.72231678298971],
        [51.7724004541957, 5.72920358640274],
        [51.7709651365414, 5.73206769792463],
        [51.7652336034063, 5.74007284815235],
        [51.759155369953, 5.74462410547083],
        [51.7552047978059, 5.75321479511336],
        [51.7508895002612, 5.76409993489855],
        [51.7501327876771, 5.77731251108568],
        [51.7525530680489, 5.79974929891457],
        [51.7553490708757, 5.81586931402758],
        [51.7559937827507, 5.83426938420126],
        [51.7566126334698, 5.85841793056398],
        [51.7529867825608, 5.8727494272732],
        [51.7468865274233, 5.88130426930642],
        [51.740104019001, 5.88237927349059],
        [51.7343794493012, 5.88633827255355],
        [51.7240173960613, 5.89024462796914],
        [51.7182599964818, 5.90166719792327],
        [51.7146080330532, 5.92057711277567],
        [51.7137904590773, 5.94296430756655],
        [51.7087441417246, 5.95381233495771],
        [51.7051602559995, 5.95721242805553],
        [51.6983770427439, 5.95827507400363],
        [51.6880125860791, 5.96216185988954],
        [51.680507399677, 5.96493574901271],
        [51.6701625963618, 5.96480366433827],
        [51.6616013717804, 5.96469440555505],
        [51.654464181035, 5.96517688378911],
        [51.649102056656, 5.96740226972191],
        [51.6408660938834, 5.97360365764107],
        [51.628771944268, 5.96656868418274],
        [51.6213398366834, 5.95443839827421],
        [51.6175168317911, 5.93318738130739],
        [51.6211785462688, 5.91259975919778],
        [51.6298083731546, 5.89722310944434],
        [51.6491547561559, 5.87794350546753],
        [51.6666980882245, 5.86264443477306],
        [51.6749533058449, 5.85010797714572],
        [51.6810822283871, 5.83352877309447],
        [51.6858049160627, 5.81061862974191],
      ],
      [
        [51.5716535036162, 5.74228735948347],
        [51.5726533590188, 5.75541464033435],
        [51.5748330265139, 5.7709378971369],
        [51.5774879585153, 5.77716294728356],
        [51.5813316516975, 5.78339911095343],
        [51.5875474318935, 5.79132768285725],
        [51.5936140323554, 5.79925707753764],
        [51.5973061917952, 5.80597327517447],
        [51.5989048489617, 5.81601236441529],
        [51.5975335055993, 5.82506875129015],
        [51.595135547145, 5.83029599978934],
        [51.5906701273237, 5.83192278896889],
        [51.5879883143428, 5.83356681257574],
        [51.5850146847897, 5.83377615046462],
        [51.5827960498964, 5.83089122891647],
        [51.5778964859946, 5.82941192563144],
        [51.5708750193602, 5.8386460607917],
        [51.5675892920363, 5.84266804617557],
        [51.5611923568474, 5.84403471303995],
        [51.5569114961912, 5.83636110336893],
        [51.5542892819088, 5.8222671937129],
        [51.550897933558, 5.81484360918557],
        [51.5449559532938, 5.81383408633249],
        [51.5391634664537, 5.81258787035233],
        [51.5332523237778, 5.80299933701191],
        [51.5294410665803, 5.78771266024658],
        [51.5287515504848, 5.77174011534572],
        [51.530128680716, 5.75959783421174],
        [51.5340284473443, 5.74842816343545],
        [51.5392648875611, 5.73726688530024],
        [51.5473153480511, 5.72922327541044],
        [51.5540172304905, 5.72474345887213],
        [51.5614539339027, 5.72312943295697],
        [51.5673884081738, 5.72698948853745],
        [51.5716535036162, 5.74228735948347],
      ],
      [
        [51.6259397534966, 5.6903919223185],
        [51.6266354166212, 5.6951932206622],
        [51.6260332840695, 5.69805491744354],
        [51.624095905071, 5.6999520685609],
        [51.6209738828814, 5.70016930507897],
        [51.6193615320176, 5.69584940673109],
        [51.620229398194, 5.6913852583773],
        [51.6230849253389, 5.68872147229509],
        [51.6259397534966, 5.6903919223185],
      ],
    ],
  },
}

// Real names extracted from KML files
const REAL_NAMES = {
  Natuurgebied: [
    'De Pannenhoef',
    'Markiezaat',
    'De Mortelen',
    'Landschotse Heide',
    'De Groote Peel',
    'Kampina',
    'De Loonse en Drunense Duinen',
    'De Maashorst',
    'Mortelen',
    'Tongelaar',
    'Nemerlaer',
    'Rovertsche Heide',
    'Mattemburgh',
    'Breugelse Beemden',
    'Nuenens Broek',
    'Oude Hondsberg',
    'Neterselsche heide',
    'De Vilt',
    'Herbertusbossen',
    'Gijzenrooi',
    'Stratumse Heide',
    'Achtereinds Laag',
    'Moerputten',
    'Valkenhorst',
    'De Regte Heide',
    'Beleven',
    'Annaninas Rust',
    'Spinsterberg',
    'De Kraaijenbergse Plas',
    'Bosreservaat Mattemburgh',
  ],
  Infopunt: [
    'Bezoekerscentrum De Kraaijenberg',
    'Natuurcentrum De Maashorst',
    'Informatiepunt De Pannenhoef',
    'Bezoekerscentrum De Groote Peel',
    'Informatiepunt Markiezaat',
    'Natuurcentrum De Mortelen',
    'Bezoekerscentrum Kampina',
    'Informatiepunt Landschotse Heide',
    'Natuurcentrum Tongelaar',
    'Bezoekerscentrum Nemerlaer',
  ],
  Horeca: [
    'Restaurant De Pannenhoef',
    'Café De Mortelen',
    'Eetcafé De Heide',
    'Brasserie Het Woud',
    'Restaurant Markiezaat',
    'Café De Peel',
    'Eetcafé Kampina',
    'Brasserie Tongelaar',
    'Restaurant Nemerlaer',
    'Café De Maashorst',
  ],
  Erfgoed: [
    'Kasteel Heeswijk',
    'Landgoed Nemerlaer',
    'Fort Bakkerskil',
    'Kasteel Heeze',
    'Kasteel Tongelaar',
    'Landgoed De Mortelen',
    'Kasteel De Pannenhoef',
    'Fort De Roovere',
    'Landgoed Mattemburgh',
    'Kasteel Ravenstein',
  ],
  Wandelroute: [
    'Wandelroute De Pannenhoef - Geel - 4.4 km',
    'Wandelroute Markiezaat - Rood - 6.2 km',
    'Wandelroute De Mortelen - Geel - 4.4 km',
    'Wandelroute Landschotse Heide - Blauw - 7.4 km',
    'Wandelroute Tongelaar - Rood - 5.2 km',
    'Wandelroute Tongelaar - Blauw - 3.5 km',
    'Wandelroute Nemerlaer - Geel - 3.8 km',
    'Wandelroute Rovertsche Heide - Geel - 3.0 km',
    'Wandelroute Rovertsche Heide - Blauw - 7.4 km',
    'Wandelroute Rovertsche Heide - Rood - 6.5 km',
    'Wandelroute Mattemburgh - Rood - 5.1 km',
    'Wandelroute Breugelse Beemden - 6.0 km',
    'Wandelroute Nuenens Broek - 4.3 km',
    'Wandelroute Oude Hondsberg - 2.1 km',
    'Wandelroute Oude Hondsberg - 2.2 km',
    'Wandelroute Oude Hondsberg - 2.6 km',
    'Wandelroute Oude Hondsberg - 4.3 km',
    'Wandelroute De Vilt - 5.5 km',
    'Wandelroute Herbertusbossen - 4.7 km',
    'Wandelroute Gijzenrooi - 3.2 km',
    'Wandelroute Achtereinds Laag - 3.8 km',
    'Wandelroute Moerputten - 2.2 km',
    'Wandelroute De Regte Heide - 6.8 km',
    'Wandelroute Beleven - 2.9 km',
    'Wandelroute Beleven - 3.9 km',
    'Wandelroute Beleven - 6.0 km',
    'Wandelroute Annaninas Rust - 4.5 km',
    'Wandelroute Spinsterberg - 3.2 km',
  ],
  Fietsroute: [
    'Fietsroute Land van Heusden en Altena - 12.7 km',
    'Fietsroute Land van Heusden en Altena - 38.3 km',
    'Fietsroute Land van Heusden en Altena - 30.2 km',
    'Fietsroute Brabantse Wal - 25.0 km',
    'Fietsroute De Kempen - 30.0 km',
    'Fietsroute Maas en Peel - 35.0 km',
    'Fietsroute Hart van het Groene Woud - 28.0 km',
    'Fietsroute Ten Oosten van Tilburg - 22.0 km',
    'Fietsroute Ten Zuiden van Den Bosch - 32.0 km',
    'Fietsroute De Groote Heide - 27.0 km',
  ],
  Ruiterpad: [
    'Ruiterpad De Pannenhoef',
    'Ruiterpad De Mortelen',
    'Ruiterpad Markiezaat',
    'Ruiterpad Landschotse Heide',
    'Ruiterpad Kampina',
    'Ruiterpad De Maashorst',
    'Ruiterpad Tongelaar',
    'Ruiterpad Nemerlaer',
  ],
  'Rolstoel- en kinderwagenroute': [
    'Rolstoelroute De Pannenhoef',
    'Kinderwagenroute De Mortelen',
    'Rolstoelroute Markiezaat',
    'Kinderwagenroute Kampina',
    'Rolstoelroute De Maashorst',
    'Kinderwagenroute Tongelaar',
    'Rolstoelroute Nemerlaer',
    'Kinderwagenroute Landschotse Heide',
  ],
  Kinderactiviteit: [
    'Speelbos De Pannenhoef',
    'Natuurspeelplaats De Mortelen',
    'Kinderactiviteit Landschotse Heide',
    'Speelbos Markiezaat',
    'Natuurspeelplaats Kampina',
    'Kinderactiviteit De Maashorst',
    'Speelbos Tongelaar',
    'Natuurspeelplaats Nemerlaer',
    'Kinderactiviteit De Groote Peel',
    'Speelbos De Loonse en Drunense Duinen',
  ],
  Uitkijkpunt: [
    'Uitkijktoren De Pannenhoef',
    'Uitkijkpunt Markiezaat',
    'Uitkijktoren De Groote Peel',
    'Uitkijkpunt De Mortelen',
    'Uitkijktoren Kampina',
    'Uitkijkpunt Landschotse Heide',
    'Uitkijktoren De Maashorst',
    'Uitkijkpunt Tongelaar',
    'Uitkijktoren Nemerlaer',
    'Uitkijkpunt De Loonse en Drunense Duinen',
  ],
  Parkeerplaats: [
    'Parkeerplaats De Pannenhoef',
    'Parkeerplaats Markiezaat',
    'Parkeerplaats De Mortelen',
    'Parkeerplaats Landschotse Heide',
    'Parkeerplaats Kampina',
    'Parkeerplaats De Maashorst',
    'Parkeerplaats Tongelaar',
    'Parkeerplaats Nemerlaer',
    'Parkeerplaats De Groote Peel',
    'Parkeerplaats De Loonse en Drunense Duinen',
    'Parkeerplaats Rovertsche Heide',
    'Parkeerplaats Mattemburgh',
    'Parkeerplaats Breugelse Beemden',
    'Parkeerplaats Nuenens Broek',
    'Parkeerplaats Oude Hondsberg',
  ],
  Activiteit: [
    'Natuurwandeling met gids',
    'Vogelexcursie',
    'Fotoworkshop in de natuur',
    'Nachtwandeling',
    'Kinderactiviteit: Natuur ontdekken',
    'Workshop: Natuurfotografie',
    'Excursie: Planten en bloemen',
    'Natuurbeheer activiteit',
    'Vogelkijkexcursie',
    'Natuurworkshop voor gezinnen',
  ],
  Project: [
    'Herstelproject heidegebied',
    'Natuurontwikkelingsproject',
    'Herstelproject beekdal',
    'Biodiversiteitsproject',
    'Herstelproject vennen',
    'Natuurbeheerproject',
    'Herstelproject bosgebied',
    'Ecologisch herstelproject',
    'Natuurontwikkeling landbouwgrond',
    'Herstelproject cultuurhistorisch landschap',
  ],
  '360° view': [
    '360° view De Pannenhoef',
    '360° view Markiezaat',
    '360° view De Mortelen',
  ],
  // Volunteer group categories
  Weidevogelbescherming: [
    'Vrijwilligersgroep Weidevogelbescherming Brabantse Wal',
    'Vrijwilligersgroep Weidevogelbescherming Baronie van Breda',
    'Vrijwilligersgroep Weidevogelbescherming De Kempen',
    'Vrijwilligersgroep Weidevogelbescherming Maas en Peel',
    'Vrijwilligersgroep Weidevogelbescherming Hart van het Groene Woud',
  ],
  Uilenbescherming: [
    'Vrijwilligersgroep Uilenbescherming Brabantse Wal',
    'Vrijwilligersgroep Uilenbescherming Baronie van Breda',
    'Vrijwilligersgroep Uilenbescherming De Kempen',
    'Vrijwilligersgroep Uilenbescherming Maas en Peel',
    'Vrijwilligersgroep Uilenbescherming Hart van het Groene Woud',
  ],
  Erfvogelbescherming: [
    'Vrijwilligersgroep Erfvogelbescherming Brabantse Wal',
    'Vrijwilligersgroep Erfvogelbescherming Baronie van Breda',
    'Vrijwilligersgroep Erfvogelbescherming De Kempen',
    'Vrijwilligersgroep Erfvogelbescherming Maas en Peel',
  ],
  Vleermuizenbescherming: [
    'Vrijwilligersgroep Vleermuizenbescherming Brabantse Wal',
    'Vrijwilligersgroep Vleermuizenbescherming Baronie van Breda',
    'Vrijwilligersgroep Vleermuizenbescherming De Kempen',
    'Vrijwilligersgroep Vleermuizenbescherming Maas en Peel',
    'Vrijwilligersgroep Vleermuizenbescherming Hart van het Groene Woud',
  ],
  'Natuur- & Landschapbescherming': [
    'Vrijwilligersgroep Natuur- & Landschapbescherming Brabantse Wal',
    'Vrijwilligersgroep Natuur- & Landschapbescherming Baronie van Breda',
    'Vrijwilligersgroep Natuur- & Landschapbescherming De Kempen',
    'Vrijwilligersgroep Natuur- & Landschapbescherming Maas en Peel',
    'Vrijwilligersgroep Natuur- & Landschapbescherming Hart van het Groene Woud',
  ],
  'Soorten monitoring': [
    'Vrijwilligersgroep Soorten monitoring Brabantse Wal',
    'Vrijwilligersgroep Soorten monitoring Baronie van Breda',
    'Vrijwilligersgroep Soorten monitoring De Kempen',
    'Vrijwilligersgroep Soorten monitoring Maas en Peel',
  ],
  'Gidsen & Voorlichting': [
    'Vrijwilligersgroep Gidsen & Voorlichting Brabantse Wal',
    'Vrijwilligersgroep Gidsen & Voorlichting Baronie van Breda',
    'Vrijwilligersgroep Gidsen & Voorlichting De Kempen',
    'Vrijwilligersgroep Gidsen & Voorlichting Maas en Peel',
    'Vrijwilligersgroep Gidsen & Voorlichting Hart van het Groene Woud',
  ],
  'Terreinen Brabants Landschap': [
    'Vrijwilligersgroep Terreinen Brabants Landschap Brabantse Wal',
    'Vrijwilligersgroep Terreinen Brabants Landschap Baronie van Breda',
    'Vrijwilligersgroep Terreinen Brabants Landschap De Kempen',
    'Vrijwilligersgroep Terreinen Brabants Landschap Maas en Peel',
    'Vrijwilligersgroep Terreinen Brabants Landschap Hart van het Groene Woud',
    '360° view Landschotse Heide',
    '360° view Kampina',
    '360° view De Maashorst',
    '360° view Tongelaar',
    '360° view Nemerlaer',
    '360° view De Groote Peel',
    '360° view Uitkijktoren',
  ],
}

// Region distribution for POIs (which POIs belong to which regions)
const REGION_DISTRIBUTION = {
  1: ['Brabantse Wal'], // Markiezaat, Mattemburgh, etc.
  2: ['Baronie van Breda'], // De Pannenhoef, etc.
  3: ['Land van Heusden en Altena'], // Tongelaar, etc.
  4: ['Hart van het Groene Woud'], // De Mortelen, Nemerlaer, etc.
  5: ['Ten Oosten van Tilburg'], // Rovertsche Heide, etc.
  6: ['Ten Zuiden van Den Bosch'], // Various
  7: ['De Kempen'], // Landschotse Heide, etc.
  8: ['De Groote Heide'], // Various
  9: ['Maas en Peel'], // De Groote Peel, etc.
}

// Generate a slug from a name
function generateSlug(name) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .substring(0, 100) // Limit length
}

// Generate a unique ID
let idCounter = 10000
function generateId() {
  return `dummy-${idCounter++}`
}

// Generate realistic coordinates within a region
// Uses golden angle distribution to create natural clustering patterns for testing
function generateCoordinates(region, index = 0) {
  // Add some variance based on index to spread markers
  const variance = 0.15
  const angle = (index * 137.5) % 360 // Golden angle for distribution (creates natural clusters)
  const distance = (index % 5) * 0.02 + 0.01

  const latOffset = Math.cos((angle * Math.PI) / 180) * distance
  const lngOffset = Math.sin((angle * Math.PI) / 180) * distance

  const lat = region.lat + latOffset + (Math.random() - 0.5) * variance
  const lng = region.lng + lngOffset + (Math.random() - 0.5) * variance

  return {
    lat: parseFloat(lat.toFixed(6)),
    lng: parseFloat(lng.toFixed(6)),
  }
}

// Intro texts for each category (short intro that appears in the styled box)
const INTRO_TEXTS = {
  Natuurgebied: [
    '<p>Een prachtig natuurgebied met een rijke biodiversiteit en talloze mogelijkheden voor natuurbeleving.</p>',
    '<p>Ontdek dit unieke natuurgebied met zijn afwisselende landschap en bijzondere flora en fauna.</p>',
    '<p>Dit gebied biedt rust, ruimte en prachtige natuur voor wandelaars, fietsers en natuurliefhebbers.</p>',
    '<p>Een belangrijk leefgebied voor vele plant- en diersoorten, waar bezoekers kunnen genieten van de natuur.</p>',
  ],
  Infopunt: [
    '<p>Bezoekerscentrum met uitgebreide informatie over het gebied, wandelkaarten en activiteiten.</p>',
    '<p>Informatiepunt waar u terecht kunt voor alle informatie over het gebied en de mogelijkheden.</p>',
    '<p>Natuurcentrum met tentoonstellingen en regelmatige activiteiten voor jong en oud.</p>',
  ],
  Horeca: [
    '<p>Gezellig restaurant/café in het hart van het natuurgebied met een prachtig terras.</p>',
    '<p>Eetcafé met lokale gerechten, perfect voor een pauze tijdens uw wandeling of fietstocht.</p>',
    '<p>Brasserie met een uitgebreide kaart en mooi uitzicht op het omliggende natuurgebied.</p>',
  ],
  Erfgoed: [
    '<p>Historisch erfgoed met een rijke geschiedenis die het verhaal van de streek vertelt.</p>',
    '<p>Kasteel of landgoed met een indrukwekkende geschiedenis en prachtige omgeving.</p>',
    '<p>Historische locatie die een belangrijke rol heeft gespeeld in de geschiedenis van de regio.</p>',
  ],
  Wandelroute: [
    '<p>Mooie wandelroute door het gebied, goed gemarkeerd en geschikt voor alle niveaus.</p>',
    '<p>Wandelroute met prachtige uitzichten en rustige plekken om te genieten van de natuur.</p>',
    '<p>Uitdagende wandelroute door verschillende landschapstypen voor ervaren wandelaars.</p>',
  ],
  Fietsroute: [
    '<p>Uitdagende fietsroute door het gebied, geschikt voor recreatieve en sportieve fietsers.</p>',
    '<p>Mooie fietsroute die verschillende natuurgebieden met elkaar verbindt.</p>',
    '<p>Fietsroute met een goede mix van natuur en cultuur langs verschillende bezienswaardigheden.</p>',
  ],
  Ruiterpad: [
    '<p>Speciaal aangelegd ruiterpad door het gebied, geschikt voor ruiters van alle niveaus.</p>',
    '<p>Ruiterpad dat door het natuurgebied loopt en ruiters een mooie route biedt.</p>',
  ],
  'Rolstoel- en kinderwagenroute': [
    '<p>Toegankelijke route geschikt voor rolstoelgebruikers en kinderwagens, verhard en vlak.</p>',
    '<p>Wandelroute die volledig toegankelijk is voor mensen met een beperking.</p>',
  ],
  Kinderactiviteit: [
    '<p>Leuke activiteit voor kinderen in de natuur, waar ze kunnen spelen en ontdekken.</p>',
    '<p>Natuurspeelplaats waar kinderen vrij kunnen spelen en de natuur kunnen ontdekken.</p>',
    '<p>Speelbos met natuurlijke speelelementen voor klimmen, klauteren en spelen.</p>',
  ],
  Uitkijkpunt: [
    '<p>Prachtig uitkijkpunt met een weids uitzicht over het gebied en het landschap.</p>',
    '<p>Uitkijktoren die een panoramisch uitzicht biedt over het omliggende natuurgebied.</p>',
    '<p>Uitkijkpunt op een natuurlijke verhoging met weids uitzicht over het gebied.</p>',
  ],
  Parkeerplaats: [
    '<p>Parkeerplaats voor bezoekers van het gebied, startpunt voor verschillende routes.</p>',
    '<p>Startpunt voor verschillende routes door het gebied, goed bereikbaar en ruim.</p>',
  ],
  Activiteit: [
    '<p>Leuke activiteit in de natuur voor jong en oud. Ontdek het gebied op een actieve en leerzame manier.</p>',
    '<p>Georganiseerde activiteit waarbij u het gebied op een bijzondere manier kunt beleven.</p>',
    '<p>Interactieve activiteit waarbij u meer leert over de natuur en het landschap.</p>',
  ],
  Project: [
    '<p>Natuurbeheerproject gericht op het behoud en herstel van de natuurwaarden in het gebied.</p>',
    '<p>Herstelproject dat bijdraagt aan de biodiversiteit en de kwaliteit van het natuurgebied.</p>',
    '<p>Ontwikkelingsproject voor het verbeteren van de natuur- en landschapswaarden.</p>',
  ],
  '360° view': ['<p>Interactieve 360° weergave van deze locatie voor een unieke kijkervaring.</p>'],
  Regio: [
    '<p>Een prachtige regio met diverse natuurgebieden, wandelroutes en bezienswaardigheden. Ontdek de unieke karakteristieken van dit gebied.</p>',
    '<p>Deze regio biedt een rijk palet aan natuur, cultuur en recreatiemogelijkheden voor bezoekers van alle leeftijden.</p>',
    '<p>Ontdek de schoonheid van deze regio met zijn afwisselende landschappen en bijzondere natuurgebieden.</p>',
    '<p>Een regio vol verrassingen waar natuur, geschiedenis en recreatie samenkomen in een unieke mix.</p>',
  ],
}

// Description texts for each category (longer detailed content)
const DESCRIPTION_TEXTS = {
  Natuurgebied: [
    `<p>Dit prachtige natuurgebied biedt een unieke ervaring voor natuurliefhebbers. Het gebied kenmerkt zich door zijn diverse flora en fauna, en biedt talloze mogelijkheden voor wandelen, fietsen en natuurbeleving.</p>
    <p>Het gebied is het hele jaar door toegankelijk en biedt verschillende routes voor verschillende niveaus. Honden zijn welkom, mits aangelijnd. Het landschap varieert van open heidevelden tot dichte bossen, en van rustige vennen tot beekdalen.</p>
    <p>Voor vogelliefhebbers is dit gebied een waar paradijs. Er zijn verschillende vogelkijkhutten en observatiepunten waar u de lokale vogelpopulatie kunt bewonderen. Ook voor plantenliefhebbers valt er veel te ontdekken, met een grote verscheidenheid aan wilde bloemen en planten.</p>`,
    `<p>Een bijzonder natuurgebied met een rijke biodiversiteit. Het gebied is het hele jaar door toegankelijk en biedt verschillende routes voor verschillende niveaus. Honden zijn welkom, mits aangelijnd.</p>
    <p>Het gebied wordt beheerd met oog voor natuurbehoud en duurzaamheid. Er worden regelmatig excursies en activiteiten georganiseerd voor bezoekers die meer willen weten over de natuur en het beheer van het gebied.</p>
    <p>Het landschap is gevormd door eeuwenlange interactie tussen mens en natuur, wat heeft geleid tot een uniek en waardevol ecosysteem. Bezoekers kunnen hier genieten van de rust en ruimte die het gebied biedt.</p>`,
    `<p>Natuurgebied met een afwisselend landschap van bossen, heide en vennen. Ideaal voor wandelaars en natuurliefhebbers die op zoek zijn naar rust en natuurbeleving.</p>
    <p>Het gebied biedt verschillende wandelroutes, variërend van korte rondwandelingen tot langere tochten. Langs de routes zijn verschillende rustpunten en informatiepanelen te vinden die meer vertellen over de natuur en geschiedenis van het gebied.</p>
    <p>In de verschillende seizoenen biedt het gebied steeds weer nieuwe verrassingen. In het voorjaar bloeien de heidevelden, in de zomer is het gebied op zijn groenst, en in de herfst kleuren de bomen prachtig. Ook in de winter heeft het gebied zijn charme, met mogelijkheden voor winterse wandelingen.</p>`,
    `<p>Dit gebied is een belangrijk leefgebied voor vele plant- en diersoorten. Bezoekers kunnen genieten van de prachtige natuur en het unieke landschap.</p>
    <p>Het gebied maakt deel uit van een groter netwerk van natuurgebieden en draagt bij aan de ecologische verbindingen in de regio. Dit maakt het gebied niet alleen waardevol voor recreatie, maar ook voor natuurbehoud.</p>
    <p>Er worden regelmatig beheerswerkzaamheden uitgevoerd om de natuurwaarden te behouden en te versterken. Bezoekers kunnen hierdoor genieten van een goed onderhouden en toegankelijk gebied.</p>`,
  ],
  Infopunt: [
    `<p>Bezoekerscentrum met uitgebreide informatie over het gebied, de natuur en de geschiedenis. Hier kunt u terecht voor wandelkaarten, informatie over activiteiten en een kopje koffie.</p>
    <p>Het centrum heeft een permanente tentoonstelling over de natuur en geschiedenis van het gebied. Er zijn regelmatig wisselende exposities en er worden verschillende activiteiten georganiseerd voor jong en oud.</p>
    <p>Openingstijden: Dinsdag t/m zondag van 10:00 tot 17:00 uur. Het centrum is gesloten op maandag, behalve tijdens schoolvakanties. Voor groepen zijn speciale arrangementen mogelijk.</p>`,
    `<p>Informatiepunt waar bezoekers terecht kunnen voor informatie over het gebied, wandelroutes en activiteiten. Openingstijden: Dinsdag t/m zondag van 10:00 tot 17:00 uur.</p>
    <p>Bij het informatiepunt zijn verschillende wandel- en fietskaarten verkrijgbaar, evenals informatie over de flora en fauna van het gebied. Het personeel kan u adviseren over de beste routes voor uw niveau en interesses.</p>
    <p>Het informatiepunt is ook het startpunt voor verschillende georganiseerde excursies en activiteiten. Kijk op de website of vraag ter plaatse naar het actuele programma.</p>`,
    `<p>Natuurcentrum met tentoonstellingen over de lokale natuur en geschiedenis. Regelmatig worden er activiteiten en excursies georganiseerd voor jong en oud.</p>
    <p>Het centrum biedt een interactieve tentoonstelling waar bezoekers op een speelse manier meer kunnen leren over de natuur. Er zijn verschillende doe-activiteiten voor kinderen en informatieve displays voor volwassenen.</p>
    <p>Naast de tentoonstelling organiseert het centrum regelmatig excursies onder leiding van ervaren gidsen. Deze excursies zijn geschikt voor verschillende niveaus en interesses.</p>`,
  ],
  Horeca: [
    `<p>Gezellig restaurant/café gelegen in het hart van het natuurgebied. Geniet van een heerlijke maaltijd of een verfrissend drankje na uw wandeling. Het terras biedt een prachtig uitzicht over het omliggende landschap.</p>
    <p>Het restaurant serveert lokale en regionale gerechten, gemaakt met verse ingrediënten. Er is een uitgebreide kaart met zowel lunch- als dineropties, en er zijn altijd vegetarische en veganistische opties beschikbaar.</p>
    <p>Het terras is het hele jaar door geopend, en in de winter wordt er verwarming aangeboden. Het restaurant is ook geschikt voor groepen en speciale gelegenheden.</p>`,
    `<p>Eetcafé met een warme sfeer en lokale gerechten. Perfect voor een pauze tijdens uw wandeling of fietstocht door het gebied.</p>
    <p>Het eetcafé biedt een gezellige sfeer waar bezoekers kunnen genieten van een kopje koffie met gebak, een lichte lunch of een verfrissend drankje. Het personeel is vriendelijk en kan u adviseren over de beste routes in het gebied.</p>
    <p>Het eetcafé is gelegen op een centrale locatie en is een populaire ontmoetingsplek voor wandelaars en fietsers. Er is voldoende ruimte voor groepen en er zijn faciliteiten voor het opladen van elektrische fietsen.</p>`,
    `<p>Brasserie met een uitgebreide kaart en een mooi terras. Het restaurant is gelegen op een prachtige locatie met uitzicht op het natuurgebied.</p>
    <p>De brasserie serveert moderne gerechten met een regionale twist. De kaart wisselt met de seizoenen en maakt gebruik van lokale producten. Er is een goede wijnkaart en er worden regelmatig speciale menu's aangeboden.</p>
    <p>Het terras is een van de mooiste plekken in het gebied om te genieten van een maaltijd of drankje. Het uitzicht over het natuurgebied maakt elke bezoek bijzonder.</p>`,
  ],
  Erfgoed: [
    `<p>Historisch erfgoed met een rijke geschiedenis. Dit monument vertelt het verhaal van de streek en is een bezoek meer dan waard. Rondleidingen zijn mogelijk op afspraak.</p>
    <p>Het monument heeft een lange en interessante geschiedenis die teruggaat tot de middeleeuwen. Door de eeuwen heen heeft het verschillende functies gehad en heeft het verschillende eigenaren gekend. Tegenwoordig is het een belangrijk cultureel erfgoed dat bewaard wordt voor toekomstige generaties.</p>
    <p>Rondleidingen worden gegeven door ervaren gidsen die veel weten over de geschiedenis en architectuur van het monument. Voor groepen zijn speciale arrangementen mogelijk, inclusief een bezoek aan de omliggende tuinen en parken.</p>`,
    `<p>Kasteel of landgoed met een indrukwekkende geschiedenis. Het gebouw en de omgeving vertellen het verhaal van vroeger tijden.</p>
    <p>Het kasteel is een prachtig voorbeeld van de architectuur uit zijn tijd. Het gebouw en de omliggende tuinen zijn zorgvuldig gerestaureerd en onderhouden. Bezoekers kunnen genieten van de prachtige architectuur en de historische sfeer.</p>
    <p>Het landgoed omvat niet alleen het kasteel, maar ook uitgestrekte tuinen, parken en bossen. Er zijn verschillende wandelroutes die bezoekers langs de mooiste plekjes van het landgoed voeren.</p>`,
    `<p>Historische locatie die een belangrijke rol heeft gespeeld in de geschiedenis van de regio. Bezoekers kunnen hier meer leren over het verleden.</p>
    <p>De locatie heeft verschillende historische gebeurtenissen meegemaakt en heeft een belangrijke rol gespeeld in de ontwikkeling van de regio. Er zijn informatiepanelen en tentoonstellingen die meer vertellen over deze geschiedenis.</p>
    <p>Bezoekers kunnen op eigen gelegenheid de locatie verkennen, of deelnemen aan een georganiseerde rondleiding. Er zijn regelmatig speciale evenementen en activiteiten die de geschiedenis tot leven brengen.</p>`,
  ],
  Wandelroute: [
    `<p>Mooie wandelroute door het gebied. De route is goed gemarkeerd en geschikt voor wandelaars van alle niveaus. De route voert langs de mooiste plekjes van het gebied.</p>
    <p>De route is bewegwijzerd met gekleurde markeringen en informatiepanelen langs de route. Er zijn verschillende rustpunten waar bezoekers kunnen uitrusten en genieten van het uitzicht. De route is geschikt voor gezinnen met kinderen en biedt verschillende mogelijkheden voor een korte of langere wandeling.</p>
    <p>Langs de route zijn verschillende bezienswaardigheden te vinden, zoals historische gebouwen, mooie uitzichtpunten en interessante natuurverschijnselen. Er zijn informatiepanelen die meer vertellen over deze bezienswaardigheden.</p>`,
    `<p>Wandelroute met prachtige uitzichten en rustige plekken om te genieten van de natuur. De route is bewegwijzerd en biedt verschillende mogelijkheden voor een korte of langere wandeling.</p>
    <p>De route voert door verschillende landschapstypen, van open velden tot dichte bossen. Langs de route zijn verschillende rustpunten en picknickplaatsen te vinden. De route is geschikt voor wandelaars van alle niveaus en biedt voldoende uitdaging zonder te zwaar te zijn.</p>
    <p>In de verschillende seizoenen biedt de route steeds weer nieuwe verrassingen. In het voorjaar bloeien de bloemen langs de route, in de zomer is het groen op zijn mooist, en in de herfst kleuren de bomen prachtig. Ook in de winter heeft de route zijn charme, met mogelijkheden voor winterse wandelingen.</p>`,
    `<p>Uitdagende wandelroute door verschillende landschapstypen. De route is geschikt voor ervaren wandelaars en biedt mooie natuurbeleving.</p>
    <p>De route voert door afwisselend terrein met enkele steile stukken en mooie uitzichtpunten. Langs de route zijn verschillende rustpunten waar wandelaars kunnen uitrusten en genieten van het uitzicht. De route is goed bewegwijzerd maar vereist enige ervaring met wandelen in de natuur.</p>
    <p>De route biedt wandelaars de mogelijkheid om het gebied op een intensieve manier te ervaren. Er zijn verschillende varianten mogelijk, waardoor wandelaars de route kunnen aanpassen aan hun niveau en tijd.</p>`,
  ],
  Fietsroute: [
    `<p>Uitdagende fietsroute door het gebied. De route is geschikt voor zowel recreatieve als sportieve fietsers. De route is bewegwijzerd en voert langs verschillende bezienswaardigheden.</p>
    <p>De route combineert mooie natuur met interessante cultuurhistorische elementen. Langs de route zijn verschillende rustpunten en horecagelegenheden te vinden waar fietsers kunnen uitrusten en genieten van een drankje of maaltijd. De route is geschikt voor verschillende soorten fietsen, van stadsfietsen tot racefietsen.</p>
    <p>De route is bewegwijzerd met duidelijke borden en is ook beschikbaar als GPX-bestand voor navigatie-apps. Er zijn verschillende varianten mogelijk, waardoor fietsers de route kunnen aanpassen aan hun niveau en tijd.</p>`,
    `<p>Mooie fietsroute die verschillende natuurgebieden met elkaar verbindt. De route biedt afwisselend landschap en is geschikt voor alle leeftijden.</p>
    <p>De route voert door verschillende landschapstypen en biedt fietsers de mogelijkheid om verschillende natuurgebieden in één rit te ontdekken. Langs de route zijn verschillende rustpunten en informatiepanelen te vinden. De route is grotendeels vlak en geschikt voor gezinnen met kinderen.</p>
    <p>De route is goed onderhouden en biedt veilige fietspaden. Er zijn verschillende mogelijkheden om de route te verkorten of te verlengen, afhankelijk van de tijd en het niveau van de fietsers.</p>`,
    `<p>Fietsroute met een goede mix van natuur en cultuur. Langs de route zijn verschillende rustpunten en bezienswaardigheden te vinden.</p>
    <p>De route combineert mooie natuur met interessante cultuurhistorische elementen, zoals historische gebouwen, monumenten en musea. Langs de route zijn verschillende rustpunten waar fietsers kunnen uitrusten en meer kunnen leren over de geschiedenis en cultuur van het gebied.</p>
    <p>De route is geschikt voor verschillende soorten fietsers en biedt voldoende uitdaging zonder te zwaar te zijn. Er zijn verschillende varianten mogelijk, waardoor fietsers de route kunnen aanpassen aan hun interesses en tijd.</p>`,
  ],
  Ruiterpad: [
    `<p>Speciaal aangelegd ruiterpad door het gebied. Het pad is geschikt voor ruiters van alle niveaus en voert door verschillende landschapstypen met mooie uitzichten.</p>
    <p>Het ruiterpad is speciaal aangelegd voor ruiters en biedt een veilige en mooie route door het gebied. Het pad is goed onderhouden en geschikt voor verschillende soorten paarden. Langs de route zijn verschillende rustpunten waar ruiters kunnen uitrusten en hun paarden kunnen laten drinken.</p>
    <p>Het pad voert door verschillende landschapstypen en biedt ruiters de mogelijkheid om het gebied op een unieke manier te ervaren. Er zijn verschillende varianten mogelijk, waardoor ruiters de route kunnen aanpassen aan hun niveau en tijd.</p>`,
    `<p>Ruiterpad dat door het natuurgebied loopt. Het pad is goed onderhouden en biedt ruiters een mooie route door de natuur.</p>
    <p>Het pad is speciaal aangelegd voor ruiters en biedt een veilige route door het gebied. Het pad is geschikt voor verschillende soorten paarden en biedt voldoende ruimte voor het passeren van andere ruiters. Langs de route zijn verschillende rustpunten en informatiepanelen te vinden.</p>
    <p>Het pad maakt deel uit van een groter netwerk van ruiterpaden in de regio, waardoor ruiters verschillende routes kunnen combineren voor een langere rit. Er zijn verschillende mogelijkheden om de route te verkorten of te verlengen.</p>`,
  ],
  'Rolstoel- en kinderwagenroute': [
    `<p>Toegankelijke route geschikt voor rolstoelgebruikers en kinderwagens. De route is verhard en vlak, en biedt een mooie kennismaking met het gebied voor iedereen.</p>
    <p>De route is speciaal aangelegd om toegankelijk te zijn voor mensen met een beperking. Het pad is verhard en vlak, en biedt voldoende ruimte voor rolstoelen en kinderwagens. Langs de route zijn verschillende rustpunten en informatiepanelen te vinden die ook toegankelijk zijn.</p>
    <p>De route biedt bezoekers de mogelijkheid om het gebied te ontdekken, ongeacht hun mobiliteit. Er zijn verschillende mogelijkheden om de route te verkorten of te verlengen, afhankelijk van de tijd en het niveau van de bezoekers.</p>`,
    `<p>Wandelroute die volledig toegankelijk is voor mensen met een beperking. De route is verhard en biedt mooie natuurbeleving voor iedereen.</p>
    <p>De route is ontworpen met oog voor toegankelijkheid en biedt bezoekers met een beperking de mogelijkheid om het gebied te ontdekken. Het pad is verhard en vlak, en er zijn verschillende rustpunten langs de route. De route is ook geschikt voor mensen met een visuele beperking, met informatiepanelen in braille.</p>
    <p>De route maakt deel uit van een groter netwerk van toegankelijke routes in de regio. Er zijn verschillende mogelijkheden om de route te combineren met andere toegankelijke routes voor een langere wandeling.</p>`,
  ],
  Kinderactiviteit: [
    `<p>Leuke activiteit voor kinderen in de natuur. Kinderen kunnen hier spelen, ontdekken en leren over de natuur. Geschikt voor kinderen van alle leeftijden.</p>
    <p>De activiteit is speciaal ontworpen voor kinderen en biedt hen de mogelijkheid om op een speelse manier de natuur te ontdekken. Er zijn verschillende speelelementen en activiteiten die kinderen uitdagen om te spelen, te klimmen en te ontdekken. De activiteit is geschikt voor kinderen van verschillende leeftijden en biedt voldoende uitdaging voor iedereen.</p>
    <p>Onder begeleiding van ouders kunnen kinderen hier uren spelen en ontdekken. Er zijn verschillende rustpunten waar ouders kunnen uitrusten terwijl kinderen spelen. De activiteit is veilig en goed onderhouden.</p>`,
    `<p>Natuurspeelplaats waar kinderen vrij kunnen spelen en de natuur kunnen ontdekken. Onder begeleiding van ouders kunnen kinderen hier uren spelen.</p>
    <p>De natuurspeelplaats is ontworpen met natuurlijke materialen en biedt kinderen de mogelijkheid om op een speelse manier de natuur te ontdekken. Er zijn verschillende speelelementen, zoals klimbomen, waterpartijen en zandbakken. De speelplaats is geschikt voor kinderen van verschillende leeftijden en biedt voldoende uitdaging voor iedereen.</p>
    <p>De speelplaats is veilig en goed onderhouden, en er zijn verschillende rustpunten waar ouders kunnen uitrusten. De speelplaats maakt deel uit van een groter gebied waar kinderen kunnen spelen en ontdekken.</p>`,
    `<p>Speelbos met natuurlijke speelelementen. Kinderen kunnen hier klimmen, klauteren en de natuur op een speelse manier ontdekken.</p>
    <p>Het speelbos biedt kinderen de mogelijkheid om op een avontuurlijke manier de natuur te ontdekken. Er zijn verschillende speelelementen, zoals klimbomen, touwbruggen en hutten. Het speelbos is geschikt voor kinderen van verschillende leeftijden en biedt voldoende uitdaging voor iedereen.</p>
    <p>Het speelbos is veilig en goed onderhouden, en er zijn verschillende rustpunten waar ouders kunnen uitrusten. Het speelbos maakt deel uit van een groter gebied waar kinderen kunnen spelen en ontdekken, en er zijn verschillende activiteiten en excursies georganiseerd voor kinderen.</p>`,
  ],
  Uitkijkpunt: [
    `<p>Prachtig uitkijkpunt met een weids uitzicht over het gebied. Vanaf hier heeft u een mooi overzicht van het landschap. Het uitkijkpunt is toegankelijk via een korte wandeling.</p>
    <p>Het uitkijkpunt biedt bezoekers een uniek perspectief op het gebied en het omliggende landschap. Vanaf het uitkijkpunt heeft u een weids uitzicht over de verschillende landschapstypen en kunt u genieten van de prachtige natuur. Het uitkijkpunt is toegankelijk via een korte wandeling en biedt verschillende mogelijkheden om te genieten van het uitzicht.</p>
    <p>Het uitkijkpunt is een populaire bestemming voor wandelaars en natuurliefhebbers. Er zijn verschillende rustpunten en informatiepanelen die meer vertellen over het uitzicht en het gebied. Het uitkijkpunt is het hele jaar door toegankelijk en biedt in de verschillende seizoenen steeds weer nieuwe verrassingen.</p>`,
    `<p>Uitkijktoren die een panoramisch uitzicht biedt over het omliggende gebied. Vanaf de top heeft u een prachtig overzicht van het natuurgebied.</p>
    <p>De uitkijktoren is een indrukwekkend bouwwerk dat bezoekers de mogelijkheid biedt om het gebied vanuit een uniek perspectief te bekijken. Vanaf de top van de toren heeft u een panoramisch uitzicht over het omliggende gebied en kunt u genieten van de prachtige natuur. De toren is toegankelijk via een trap en biedt verschillende niveaus waar bezoekers kunnen uitrusten en genieten van het uitzicht.</p>
    <p>De toren is een populaire bestemming voor wandelaars en natuurliefhebbers. Er zijn verschillende informatiepanelen die meer vertellen over het uitzicht en het gebied. De toren is het hele jaar door toegankelijk en biedt in de verschillende seizoenen steeds weer nieuwe verrassingen.</p>`,
    `<p>Uitkijkpunt op een natuurlijke verhoging in het landschap. Vanaf hier kunt u genieten van het weidse uitzicht over het gebied.</p>
    <p>Het uitkijkpunt is gelegen op een natuurlijke verhoging in het landschap en biedt bezoekers een uniek perspectief op het gebied. Vanaf het uitkijkpunt heeft u een weids uitzicht over de verschillende landschapstypen en kunt u genieten van de prachtige natuur. Het uitkijkpunt is toegankelijk via een korte wandeling en biedt verschillende mogelijkheden om te genieten van het uitzicht.</p>
    <p>Het uitkijkpunt is een populaire bestemming voor wandelaars en natuurliefhebbers. Er zijn verschillende rustpunten en informatiepanelen die meer vertellen over het uitzicht en het gebied. Het uitkijkpunt is het hele jaar door toegankelijk en biedt in de verschillende seizoenen steeds weer nieuwe verrassingen.</p>`,
  ],
  Parkeerplaats: [
    `<p>Parkeerplaats voor bezoekers van het gebied. Vanaf hier starten verschillende wandel- en fietsroutes. Parkeren is gratis. Let op de openingstijden van het gebied.</p>
    <p>De parkeerplaats is een centraal startpunt voor verschillende activiteiten in het gebied. Vanaf de parkeerplaats starten verschillende wandel- en fietsroutes, en er zijn verschillende informatiepanelen die meer vertellen over de mogelijkheden in het gebied. De parkeerplaats is goed bereikbaar en biedt voldoende parkeerruimte voor bezoekers.</p>
    <p>Parkeren is gratis, maar let op de openingstijden van het gebied. Er zijn verschillende faciliteiten bij de parkeerplaats, zoals toiletten en informatiepanelen. De parkeerplaats is het hele jaar door toegankelijk, maar in drukke periodes kan het druk zijn.</p>`,
    `<p>Startpunt voor verschillende routes door het gebied. De parkeerplaats is goed bereikbaar en biedt voldoende parkeerruimte voor bezoekers.</p>
    <p>De parkeerplaats is een ideaal startpunt voor verschillende activiteiten in het gebied. Vanaf de parkeerplaats starten verschillende wandel- en fietsroutes, en er zijn verschillende informatiepanelen die meer vertellen over de mogelijkheden. De parkeerplaats is goed bereikbaar met de auto en biedt voldoende parkeerruimte, ook voor grotere voertuigen zoals campers.</p>
    <p>Er zijn verschillende faciliteiten bij de parkeerplaats, zoals toiletten, informatiepanelen en rustpunten. De parkeerplaats is het hele jaar door toegankelijk en biedt bezoekers een goede basis voor hun bezoek aan het gebied.</p>`,
  ],
  Activiteit: [
    `<p>Leuke activiteit in de natuur voor jong en oud. Ontdek het gebied op een actieve en leerzame manier.</p>
    <p>Deze activiteit biedt bezoekers de mogelijkheid om het gebied op een bijzondere manier te beleven. Onder begeleiding van ervaren gidsen of instructeurs kunt u het gebied ontdekken en meer leren over de natuur, het landschap en de geschiedenis. De activiteit is geschikt voor verschillende niveaus en interesses.</p>
    <p>Er zijn verschillende soorten activiteiten mogelijk, zoals wandelingen, workshops, excursies en educatieve programma's. De activiteiten worden regelmatig georganiseerd en zijn geschikt voor individuele bezoekers, gezinnen en groepen. Kijk op de website of vraag ter plaatse naar het actuele programma.</p>`,
    `<p>Georganiseerde activiteit waarbij u het gebied op een bijzondere manier kunt beleven.</p>
    <p>Deze activiteit is speciaal ontworpen om bezoekers het gebied op een unieke manier te laten ervaren. Met verschillende activiteiten en programma's kunt u het gebied ontdekken en meer leren over de natuur, het landschap en de geschiedenis. De activiteit is geschikt voor verschillende leeftijden en niveaus.</p>
    <p>De activiteiten worden begeleid door ervaren gidsen en instructeurs die u kunnen helpen om het beste uit uw bezoek te halen. Er zijn verschillende mogelijkheden om de activiteit aan te passen aan uw interesses en niveau. De activiteit is een leuke manier om het gebied te ontdekken en meer te leren over de natuur.</p>`,
    `<p>Interactieve activiteit waarbij u meer leert over de natuur en het landschap.</p>
    <p>Deze activiteit combineert leren met beleven en biedt bezoekers de mogelijkheid om op een interactieve manier meer te leren over de natuur en het landschap. Met verschillende activiteiten en programma's kunt u het gebied ontdekken en meer leren over de flora, fauna en geschiedenis van het gebied.</p>
    <p>De activiteit is geschikt voor verschillende leeftijden en niveaus, en er zijn verschillende mogelijkheden om de activiteit aan te passen aan uw interesses. De activiteit wordt begeleid door ervaren gidsen en instructeurs die u kunnen helpen om het beste uit uw bezoek te halen.</p>`,
  ],
  Project: [
    `<p>Natuurbeheerproject gericht op het behoud en herstel van de natuurwaarden in het gebied.</p>
    <p>Dit project is gericht op het behoud en herstel van de natuurwaarden in het gebied. Met verschillende maatregelen en werkzaamheden wordt gewerkt aan het verbeteren van de biodiversiteit, het herstellen van natuurlijke processen en het behouden van de unieke karakteristieken van het gebied. Het project wordt uitgevoerd in samenwerking met verschillende partners en vrijwilligers.</p>
    <p>Het project heeft verschillende doelen, zoals het verbeteren van de waterkwaliteit, het herstellen van natuurlijke habitats en het bevorderen van de biodiversiteit. Er worden regelmatig werkzaamheden uitgevoerd en bezoekers kunnen meer leren over het project via informatiepanelen en excursies. Het project draagt bij aan het behoud van het gebied voor toekomstige generaties.</p>`,
    `<p>Herstelproject dat bijdraagt aan de biodiversiteit en de kwaliteit van het natuurgebied.</p>
    <p>Dit herstelproject is gericht op het verbeteren van de biodiversiteit en de kwaliteit van het natuurgebied. Met verschillende maatregelen en werkzaamheden wordt gewerkt aan het herstellen van natuurlijke processen en het verbeteren van de leefomgeving voor planten en dieren. Het project wordt uitgevoerd met oog voor duurzaamheid en natuurbehoud.</p>
    <p>Het project heeft verschillende resultaten, zoals het verbeteren van de waterkwaliteit, het herstellen van natuurlijke habitats en het bevorderen van de biodiversiteit. Er worden regelmatig monitoring en evaluatie uitgevoerd om de voortgang van het project te volgen. Bezoekers kunnen meer leren over het project via informatiepanelen en excursies.</p>`,
    `<p>Ontwikkelingsproject voor het verbeteren van de natuur- en landschapswaarden.</p>
    <p>Dit ontwikkelingsproject is gericht op het verbeteren van de natuur- en landschapswaarden in het gebied. Met verschillende maatregelen en werkzaamheden wordt gewerkt aan het ontwikkelen van nieuwe natuur, het verbeteren van bestaande natuur en het behouden van de unieke karakteristieken van het landschap. Het project wordt uitgevoerd in samenwerking met verschillende partners.</p>
    <p>Het project heeft verschillende doelen, zoals het ontwikkelen van nieuwe natuur, het verbeteren van de landschapskwaliteit en het bevorderen van de biodiversiteit. Er worden regelmatig werkzaamheden uitgevoerd en bezoekers kunnen meer leren over het project via informatiepanelen en excursies. Het project draagt bij aan het behoud en de ontwikkeling van het gebied voor toekomstige generaties.</p>`,
  ],
  '360° view': [
    `<p>Interactieve 360° weergave van deze locatie. Ontdek het gebied vanuit alle hoeken en geniet van een unieke kijkervaring.</p>
    <p>De 360° weergave biedt bezoekers de mogelijkheid om het gebied vanuit een uniek perspectief te bekijken. Met de interactieve weergave kunt u het gebied vanuit alle hoeken ontdekken en genieten van een unieke kijkervaring. De weergave is beschikbaar via een speciale app of website.</p>
    <p>De 360° weergave is een innovatieve manier om het gebied te ontdekken en biedt bezoekers de mogelijkheid om het gebied te bekijken voordat ze het bezoeken, of om het gebied opnieuw te beleven na hun bezoek.</p>`,
  ],
  Regio: [
    `<p>Deze prachtige regio kenmerkt zich door een grote diversiteit aan natuurgebieden, elk met hun eigen unieke karakteristieken. Van uitgestrekte heidevelden tot dichte bossen, van rustige vennen tot beekdalen - de regio biedt voor ieder wat wils.</p>
    <p>Bezoekers kunnen genieten van talloze wandel- en fietsroutes die door de mooiste delen van de regio voeren. Er zijn verschillende bezoekerscentra en informatiepunten waar u meer kunt leren over de natuur, geschiedenis en cultuur van het gebied.</p>
    <p>De regio is het hele jaar door een bezoek waard. In het voorjaar bloeien de heidevelden, in de zomer is het gebied op zijn groenst, in de herfst kleuren de bomen prachtig, en ook in de winter heeft de regio zijn charme met mogelijkheden voor winterse wandelingen.</p>`,
    `<p>Een regio vol verrassingen waar natuur, geschiedenis en recreatie samenkomen. De regio biedt een rijk palet aan mogelijkheden voor natuurliefhebbers, wandelaars, fietsers en gezinnen.</p>
    <p>Het gebied wordt beheerd met oog voor natuurbehoud en duurzaamheid. Er worden regelmatig excursies en activiteiten georganiseerd voor bezoekers die meer willen weten over de natuur en het beheer van het gebied.</p>
    <p>De regio maakt deel uit van een groter netwerk van natuurgebieden en draagt bij aan de ecologische verbindingen in de regio. Dit maakt het gebied niet alleen waardevol voor recreatie, maar ook voor natuurbehoud en biodiversiteit.</p>`,
    `<p>Ontdek de schoonheid van deze regio met zijn afwisselende landschappen en bijzondere natuurgebieden. De regio biedt rust, ruimte en prachtige natuur voor iedereen die op zoek is naar ontspanning en natuurbeleving.</p>
    <p>Er zijn verschillende bezienswaardigheden te vinden, zoals historische gebouwen, mooie uitzichtpunten en interessante natuurverschijnselen. Langs de routes zijn informatiepanelen te vinden die meer vertellen over deze bezienswaardigheden.</p>
    <p>De regio is goed bereikbaar en biedt verschillende startpunten voor wandelingen en fietstochten. Er zijn voldoende parkeerplaatsen en horecagelegenheden waar bezoekers kunnen uitrusten en genieten van een drankje of maaltijd.</p>`,
    `<p>Deze regio biedt een unieke mix van natuur, cultuur en recreatie. Bezoekers kunnen genieten van prachtige natuurgebieden, interessante cultuurhistorische elementen en talloze recreatiemogelijkheden.</p>
    <p>Het landschap is gevormd door eeuwenlange interactie tussen mens en natuur, wat heeft geleid tot een uniek en waardevol ecosysteem. Bezoekers kunnen hier genieten van de rust en ruimte die het gebied biedt, terwijl ze tegelijkertijd meer leren over de geschiedenis en natuur van de regio.</p>
    <p>Er worden regelmatig beheerswerkzaamheden uitgevoerd om de natuurwaarden te behouden en te versterken. Bezoekers kunnen hierdoor genieten van een goed onderhouden en toegankelijk gebied dat klaar is voor toekomstige generaties.</p>`,
  ],
}

// Popup descriptions for each category (short version for popups)
const POPUP_DESCRIPTIONS = {
  Natuurgebied: [
    'Dit prachtige natuurgebied biedt een unieke ervaring voor natuurliefhebbers. Het gebied kenmerkt zich door zijn diverse flora en fauna, en biedt talloze mogelijkheden voor wandelen, fietsen en natuurbeleving.',
    'Een bijzonder natuurgebied met een rijke biodiversiteit. Het gebied is het hele jaar door toegankelijk en biedt verschillende routes voor verschillende niveaus. Honden zijn welkom, mits aangelijnd.',
    'Natuurgebied met een afwisselend landschap van bossen, heide en vennen. Ideaal voor wandelaars en natuurliefhebbers die op zoek zijn naar rust en natuurbeleving.',
    'Dit gebied is een belangrijk leefgebied voor vele plant- en diersoorten. Bezoekers kunnen genieten van de prachtige natuur en het unieke landschap.',
  ],
  Infopunt: [
    'Bezoekerscentrum met uitgebreide informatie over het gebied, de natuur en de geschiedenis. Hier kunt u terecht voor wandelkaarten, informatie over activiteiten en een kopje koffie.',
    'Informatiepunt waar bezoekers terecht kunnen voor informatie over het gebied, wandelroutes en activiteiten. Openingstijden: Dinsdag t/m zondag van 10:00 tot 17:00 uur.',
    'Natuurcentrum met tentoonstellingen over de lokale natuur en geschiedenis. Regelmatig worden er activiteiten en excursies georganiseerd voor jong en oud.',
  ],
  Horeca: [
    'Gezellig restaurant/café gelegen in het hart van het natuurgebied. Geniet van een heerlijke maaltijd of een verfrissend drankje na uw wandeling. Het terras biedt een prachtig uitzicht over het omliggende landschap.',
    'Eetcafé met een warme sfeer en lokale gerechten. Perfect voor een pauze tijdens uw wandeling of fietstocht door het gebied.',
    'Brasserie met een uitgebreide kaart en een mooi terras. Het restaurant is gelegen op een prachtige locatie met uitzicht op het natuurgebied.',
  ],
  Erfgoed: [
    'Historisch erfgoed met een rijke geschiedenis. Dit monument vertelt het verhaal van de streek en is een bezoek meer dan waard. Rondleidingen zijn mogelijk op afspraak.',
    'Kasteel of landgoed met een indrukwekkende geschiedenis. Het gebouw en de omgeving vertellen het verhaal van vroeger tijden.',
    'Historische locatie die een belangrijke rol heeft gespeeld in de geschiedenis van de regio. Bezoekers kunnen hier meer leren over het verleden.',
  ],
  Wandelroute: [
    'Mooie wandelroute door het gebied. De route is goed gemarkeerd en geschikt voor wandelaars van alle niveaus. De route voert langs de mooiste plekjes van het gebied.',
    'Wandelroute met prachtige uitzichten en rustige plekken om te genieten van de natuur. De route is bewegwijzerd en biedt verschillende mogelijkheden voor een korte of langere wandeling.',
    'Uitdagende wandelroute door verschillende landschapstypen. De route is geschikt voor ervaren wandelaars en biedt mooie natuurbeleving.',
  ],
  Fietsroute: [
    'Uitdagende fietsroute door het gebied. De route is geschikt voor zowel recreatieve als sportieve fietsers. De route is bewegwijzerd en voert langs verschillende bezienswaardigheden.',
    'Mooie fietsroute die verschillende natuurgebieden met elkaar verbindt. De route biedt afwisselend landschap en is geschikt voor alle leeftijden.',
    'Fietsroute met een goede mix van natuur en cultuur. Langs de route zijn verschillende rustpunten en bezienswaardigheden te vinden.',
  ],
  Ruiterpad: [
    'Speciaal aangelegd ruiterpad door het gebied. Het pad is geschikt voor ruiters van alle niveaus en voert door verschillende landschapstypen met mooie uitzichten.',
    'Ruiterpad dat door het natuurgebied loopt. Het pad is goed onderhouden en biedt ruiters een mooie route door de natuur.',
  ],
  'Rolstoel- en kinderwagenroute': [
    'Toegankelijke route geschikt voor rolstoelgebruikers en kinderwagens. De route is verhard en vlak, en biedt een mooie kennismaking met het gebied voor iedereen.',
    'Wandelroute die volledig toegankelijk is voor mensen met een beperking. De route is verhard en biedt mooie natuurbeleving voor iedereen.',
  ],
  Kinderactiviteit: [
    'Leuke activiteit voor kinderen in de natuur. Kinderen kunnen hier spelen, ontdekken en leren over de natuur. Geschikt voor kinderen van alle leeftijden.',
    'Natuurspeelplaats waar kinderen vrij kunnen spelen en de natuur kunnen ontdekken. Onder begeleiding van ouders kunnen kinderen hier uren spelen.',
    'Speelbos met natuurlijke speelelementen. Kinderen kunnen hier klimmen, klauteren en de natuur op een speelse manier ontdekken.',
  ],
  Uitkijkpunt: [
    'Prachtig uitkijkpunt met een weids uitzicht over het gebied. Vanaf hier heeft u een mooi overzicht van het landschap. Het uitkijkpunt is toegankelijk via een korte wandeling.',
    'Uitkijktoren die een panoramisch uitzicht biedt over het omliggende gebied. Vanaf de top heeft u een prachtig overzicht van het natuurgebied.',
    'Uitkijkpunt op een natuurlijke verhoging in het landschap. Vanaf hier kunt u genieten van het weidse uitzicht over het gebied.',
  ],
  Parkeerplaats: [
    'Parkeerplaats voor bezoekers van het gebied. Vanaf hier starten verschillende wandel- en fietsroutes. Parkeren is gratis. Let op de openingstijden van het gebied.',
    'Startpunt voor verschillende routes door het gebied. De parkeerplaats is goed bereikbaar en biedt voldoende parkeerruimte voor bezoekers.',
  ],
  Activiteit: [
    'Leuke activiteit in de natuur voor jong en oud. Ontdek het gebied op een actieve en leerzame manier. Onder begeleiding van ervaren gidsen kunt u het gebied ontdekken en meer leren over de natuur.',
    'Georganiseerde activiteit waarbij u het gebied op een bijzondere manier kunt beleven. Geschikt voor verschillende leeftijden en niveaus. Kijk op de website of vraag ter plaatse naar het actuele programma.',
    'Interactieve activiteit waarbij u meer leert over de natuur en het landschap. Combineer leren met beleven en ontdek het gebied op een unieke manier.',
  ],
  Project: [
    'Natuurbeheerproject gericht op het behoud en herstel van de natuurwaarden in het gebied. Het project draagt bij aan de biodiversiteit en de kwaliteit van het natuurgebied.',
    'Herstelproject dat bijdraagt aan de biodiversiteit en de kwaliteit van het natuurgebied. Met verschillende maatregelen wordt gewerkt aan het verbeteren van de leefomgeving voor planten en dieren.',
    'Ontwikkelingsproject voor het verbeteren van de natuur- en landschapswaarden. Het project draagt bij aan het behoud en de ontwikkeling van het gebied voor toekomstige generaties.',
  ],
  '360° view': [
    'Interactieve 360° weergave van deze locatie. Ontdek het gebied vanuit alle hoeken en geniet van een unieke kijkervaring.',
  ],
}

// Generate thumbnail path (using placeholder or realistic path structure)
function generateThumbnailPath(category, name) {
  // In dummy mode, use a single placeholder image to avoid 404 errors
  // Place your placeholder JPG at: ontdekdenatuurmodule/public-src/img/placeholder/dummy-thumbnail.jpg
  if (ENABLE_DUMMY_DATA) {
    // Use a single placeholder image for all dummy POIs
    return '/_resources/ontdekdenatuurmodule/img/placeholder/dummy-thumbnail.jpg'
  }

  // In production mode, use realistic path structure
  const slug = generateSlug(name)
  return `/_resources/ontdekdenatuurmodule/img/thumbnails/${slug}.jpg`
}

// Get a random intro for a category
function getRandomIntro(category) {
  const intros = INTRO_TEXTS[category]
  if (!intros || intros.length === 0) {
    return '<p>Dit is een interessante locatie in het gebied.</p>'
  }
  return intros[Math.floor(Math.random() * intros.length)]
}

// Get a random description for a category
function getRandomDescription(category) {
  const descriptions = DESCRIPTION_TEXTS[category]
  if (!descriptions || descriptions.length === 0) {
    return '<p>Dit is een interessante locatie in het gebied. Bezoekers kunnen hier genieten van de natuur en het landschap.</p>'
  }
  return descriptions[Math.floor(Math.random() * descriptions.length)]
}

// Get a random popup description for a category (short version)
function getRandomPopupDescription(category) {
  const descriptions = POPUP_DESCRIPTIONS[category]
  if (!descriptions || descriptions.length === 0) {
    return 'Dit is een interessante locatie in het gebied. Bezoekers kunnen hier genieten van de natuur en het landschap.'
  }
  return descriptions[Math.floor(Math.random() * descriptions.length)]
}

// Volunteer group categories
const VOLUNTEER_GROUP_CATEGORIES = [
  'Weidevogelbescherming',
  'Uilenbescherming',
  'Erfvogelbescherming',
  'Vleermuizenbescherming',
  'Natuur- & Landschapbescherming',
  'Soorten monitoring',
  'Gidsen & Voorlichting',
  'Terreinen Brabants Landschap',
]

// Generate dummy POI data
function generateDummyPois(count = 300, isVolunteerGroups = false) {
  const pois = []
  // Filter categories based on map type
  const allCategories = Object.keys(REAL_NAMES)
  const categories = isVolunteerGroups
    ? allCategories.filter((cat) => VOLUNTEER_GROUP_CATEGORIES.includes(cat))
    : allCategories.filter((cat) => !VOLUNTEER_GROUP_CATEGORIES.includes(cat))
  let globalIndex = 0

  // Ensure minimum POIs per category (at least 3 per category)
  const minPerCategory = 3
  const totalMinRequired = categories.length * minPerCategory
  const actualCount = Math.max(count, totalMinRequired)

  // First pass: ensure each category gets at least minPerCategory POIs
  categories.forEach((category) => {
    const names = REAL_NAMES[category]

    for (let i = 0; i < minPerCategory; i++) {
      const nameIndex = i % names.length
      const name = names[nameIndex]
      const region = REGION_DATA[globalIndex % REGION_DATA.length]
      const coords = generateCoordinates(region, globalIndex)

      const displayName = i >= names.length ? `${name} (${Math.floor(i / names.length) + 1})` : name
      const slug = i >= names.length ? `${generateSlug(name)}-${Math.floor(i / names.length)}` : generateSlug(name)

      const poi = {
        id: generateId(),
        className: 'PointOfInterest',
        regionId: region.id,
        name: displayName,
        slug: slug,
        lat: coords.lat,
        lng: coords.lng,
        zoom: 15,
        category: category,
        iframeLink: null,
        icon: null,
        thumbnailPath: generateThumbnailPath(category, displayName),
        gpxLinks: [],
        pdfLinks: [],
        tour360Link: category === '360° view' ? 'https://example.com/tour360' : null,
        intro: getRandomIntro(category),
        description: getRandomDescription(category),
        popupDescription: getRandomPopupDescription(category),
      }

      pois.push(poi)
      globalIndex++
    }
  })

  // Second pass: distribute remaining POIs across all categories proportionally
  const remainingCount = actualCount - pois.length
  if (remainingCount > 0) {
    let categoryIndex = 0
    let nameIndex = 0
    let itemIndex = 0

    while (pois.length < actualCount) {
      const category = categories[categoryIndex % categories.length]
      const names = REAL_NAMES[category]
      const name = names[nameIndex % names.length]

      const region = REGION_DATA[globalIndex % REGION_DATA.length]
      const coords = generateCoordinates(region, globalIndex)

      const displayName = `${name} (${itemIndex + 2})`
      const slug = `${generateSlug(name)}-${itemIndex + 1}`

      const poi = {
        id: generateId(),
        className: 'PointOfInterest',
        regionId: region.id,
        name: displayName,
        slug: slug,
        lat: coords.lat,
        lng: coords.lng,
        zoom: 15,
        category: category,
        iframeLink: null,
        icon: null,
        thumbnailPath: generateThumbnailPath(category, displayName),
        gpxLinks: [],
        pdfLinks: [],
        tour360Link: category === '360° view' ? 'https://example.com/tour360' : null,
        intro: getRandomIntro(category),
        description: getRandomDescription(category),
        popupDescription: getRandomPopupDescription(category),
      }

      pois.push(poi)
      globalIndex++

      nameIndex++
      if (nameIndex >= names.length) {
        nameIndex = 0
        itemIndex++
        categoryIndex++
      }
    }
  }

  return pois
}

// Generate dummy region data
function generateDummyRegions() {
  return REGION_DATA.map((region) => ({
    id: region.id,
    name: region.name,
    lat: region.lat,
    lng: region.lng,
    zoom: 12,
    kmlId: region.kmlId,
    tourmake: null,
    link: `/${generateSlug(region.name)}`,
    slug: generateSlug(region.name),
    image: null,
  }))
}

// Generate dummy news items for regions
function generateDummyNewsItems(count = 3) {
  const newsTitles = [
    'Nieuwe wandelroute geopend in natuurgebied',
    'Vogelkijkhut vernieuwd voor bezoekers',
    'Natuurbeheerproject van start',
    'Nieuwe fietsroute verbindt natuurgebieden',
    'Bezoekerscentrum organiseert excursie',
    'Herstelwerkzaamheden aan paden afgerond',
    'Nieuwe informatiepanelen geplaatst',
    'Natuurgebied uitgebreid met 50 hectare',
  ]

  const newsIntros = [
    '<p>Een prachtige nieuwe wandelroute is geopend die bezoekers door de mooiste delen van het gebied voert.</p>',
    '<p>De vogelkijkhut is volledig vernieuwd en biedt nu nog beter zicht op de lokale vogelpopulatie.</p>',
    '<p>Een nieuw natuurbeheerproject is van start gegaan om de biodiversiteit in het gebied te versterken.</p>',
    '<p>Een nieuwe fietsroute verbindt verschillende natuurgebieden en biedt fietsers een mooie tocht.</p>',
    '<p>Het bezoekerscentrum organiseert regelmatig excursies voor jong en oud.</p>',
    '<p>Herstelwerkzaamheden aan de paden zijn succesvol afgerond, alle routes zijn weer toegankelijk.</p>',
    '<p>Nieuwe informatiepanelen zijn geplaatst die bezoekers meer vertellen over de natuur en geschiedenis.</p>',
    '<p>Het natuurgebied is uitgebreid met 50 hectare, waardoor er meer ruimte is voor natuur en recreatie.</p>',
  ]

  const items = []
  for (let i = 0; i < count; i++) {
    const titleIndex = i % newsTitles.length
    items.push({
      title: newsTitles[titleIndex],
      intro: newsIntros[titleIndex],
      image: '/_resources/ontdekdenatuurmodule/img/placeholder/dummy-thumbnail.jpg',
    })
  }
  return items
}

// Generate dummy activity items for regions
function generateDummyActivityItems(count = 3) {
  const activityTitles = [
    'Natuurwandeling met gids',
    'Vogelexcursie voor beginners',
    'Kinderactiviteit: Natuur ontdekken',
    'Fotoworkshop in de natuur',
    'Nachtwandeling met nachtdieren',
    'Workshop natuurfotografie',
    'Familie-excursie',
    'Vroege vogelwandeling',
  ]

  const activityIntros = [
    '<p>Ontdek het gebied tijdens een begeleide natuurwandeling met een ervaren gids.</p>',
    '<p>Leer meer over vogels tijdens deze excursie speciaal voor beginners.</p>',
    '<p>Kinderen kunnen de natuur ontdekken tijdens deze leuke en leerzame activiteit.</p>',
    "<p>Leer de mooiste foto's maken tijdens deze fotoworkshop in de natuur.</p>",
    '<p>Ontdek de nachtdieren tijdens deze speciale nachtwandeling.</p>',
    '<p>Leer de technieken van natuurfotografie tijdens deze workshop.</p>',
    '<p>Een leuke excursie voor het hele gezin door het natuurgebied.</p>',
    '<p>Start de dag met een vroege wandeling en ontdek de vogels in de ochtend.</p>',
  ]

  const items = []
  for (let i = 0; i < count; i++) {
    const titleIndex = i % activityTitles.length
    items.push({
      title: activityTitles[titleIndex],
      intro: activityIntros[titleIndex],
      image: '/_resources/ontdekdenatuurmodule/img/placeholder/dummy-thumbnail.jpg',
    })
  }
  return items
}

// Generate dummy gallery images
function generateDummyGalleryImages(count = 3) {
  const images = []
  for (let i = 0; i < count; i++) {
    images.push({
      src: '/_resources/ontdekdenatuurmodule/img/placeholder/dummy-thumbnail.jpg',
      alt: `Galerij afbeelding ${i + 1}`,
    })
  }
  return images
}

// Generate detailed HTML content for markers (matching real template structure)
function generateMarkerContent(id, type, name, category, poi = null) {
  // Check if this is a region type
  const isRegion = type === 'region'

  // Get region data for the POI or if it's a region itself
  let region = null
  let regionSlug = ''

  if (isRegion) {
    // Find region by ID
    region = REGION_DATA.find((r) => r.id === parseInt(id, 10))
    regionSlug = region ? generateSlug(region.name) : ''
  } else {
    region = poi && poi.regionId ? REGION_DATA.find((r) => r.id === poi.regionId) : null
    regionSlug = region ? generateSlug(region.name) : ''
  }

  // Get intro and description from POI or use defaults
  // For regions, use 'Regio' category for intro/description
  const categoryForContent = isRegion ? 'Regio' : category
  const intro = poi && poi.intro ? poi.intro : getRandomIntro(categoryForContent)
  const description = poi && poi.description ? poi.description : getRandomDescription(categoryForContent)

  // For regions, generate more comprehensive content
  if (isRegion && region) {
    // Generate dummy news and activities for regions
    const newsItems = generateDummyNewsItems(4)
    const activityItems = generateDummyActivityItems(4)
    const galleryImages = generateDummyGalleryImages(3)

    // Build tabs navigation if we have news or activities
    const hasNews = newsItems.length > 0
    const hasActivities = activityItems.length > 0
    const showTabs = hasNews || hasActivities

    let tabsNavHtml = ''
    if (showTabs) {
      tabsNavHtml = `
        <ul class="js-tab-nav nav nav--tabs">
          <li class="nav__item"><button class="nav__link is--active" data-tab-id="aside-info">Info</button></li>
          ${
            hasNews
              ? '<li class="nav__item"><button class="nav__link" data-tab-id="aside-news">Nieuws</button></li>'
              : ''
          }
          ${
            hasActivities
              ? '<li class="nav__item"><button class="nav__link" data-tab-id="aside-activities">Activiteiten</button></li>'
              : ''
          }
        </ul>
      `
    }

    // Build gallery HTML
    let galleryHtml = ''
    if (galleryImages.length > 0) {
      galleryHtml = `
        <div class="map__aside-gallery sign">
          <div class="gallery">
            ${galleryImages
              .map(
                (img) => `
              <div class="gallery__item">
                <img src="${img.src}" alt="${img.alt}" />
              </div>
            `
              )
              .join('')}
          </div>
        </div>
      `
    }

    // Build intro section with styled box (using region color)
    const introBoxClass = regionSlug ? `island island--shadow sign bg--${regionSlug}` : 'island island--shadow sign'
    const introHtml = intro
      ? `
      <div class="${introBoxClass}">
        ${intro}
      </div>
    `
      : ''

    // Build description section
    const descriptionHtml = description ? description : ''

    // Build news tab content
    let newsTabHtml = ''
    if (hasNews) {
      newsTabHtml = `
        <div class="js-tab tab" data-tab-id="aside-news" style="display: none;">
          <h2 id="news-section" class="heading-s sign">Nieuws</h2>
          <div class="layout">
            ${newsItems
              .slice(0, 3)
              .map(
                (item) => `
              <div class="layout__cell unit-1-1 sign">
                <div class="card">
                  <div class="card__image">
                    <img src="${item.image}" alt="${item.title}" />
                  </div>
                  <div class="card__content">
                    <h3 class="card__title">${item.title}</h3>
                    ${item.intro}
                  </div>
                </div>
              </div>
            `
              )
              .join('')}
          </div>
          ${
            newsItems.length > 3
              ? `<a href="#" class="button button--ghost" target="_blank" rel="noopener">Bekijk al het nieuws</a>`
              : ''
          }
        </div>
      `
    }

    // Build activities tab content
    let activitiesTabHtml = ''
    if (hasActivities) {
      activitiesTabHtml = `
        <div class="js-tab tab" data-tab-id="aside-activities" style="display: none;">
          <h2 id="activities-section" class="heading-s sign">Activiteiten</h2>
          <div class="layout">
            ${activityItems
              .slice(0, 3)
              .map(
                (item) => `
              <div class="layout__cell unit-1-1 sign">
                <div class="card">
                  <div class="card__image">
                    <img src="${item.image}" alt="${item.title}" />
                  </div>
                  <div class="card__content">
                    <h3 class="card__title">${item.title}</h3>
                    ${item.intro}
                  </div>
                </div>
              </div>
            `
              )
              .join('')}
          </div>
          ${
            activityItems.length > 3
              ? `<a href="#" class="button button--ghost" target="_blank" rel="noopener">Bekijk alle activiteiten</a>`
              : ''
          }
        </div>
      `
    }

    // Build the full HTML matching the real template structure for regions
    return `
      <div class="map__aside-holder">
        <div class="map__aside-inner">
          ${tabsNavHtml}
          <div class="js-tab tab" data-tab-id="aside-info">
            <div class="sign">
              <div class="${headerClass}">
                <div class="heading-s color--brand-ter sign-s">${name}</div>
                ${imageHtml}
              </div>
            </div>
            ${galleryHtml}
            ${introHtml}
            ${descriptionHtml}
          </div>
          ${newsTabHtml}
          ${activitiesTabHtml}
        </div>
      </div>
    `
  }

  // For POIs (non-regions), use the existing logic
  // Build region logo section
  let regionLogoHtml = ''
  if (region && regionSlug) {
    regionLogoHtml = `
      <div class="map__aside-region is--${regionSlug}">
        <img class="map__aside-region-logo" src="_resources/ontdekdenatuurmodule/img/regions/${regionSlug}.svg" alt="${region.name}" width="425" height="57">
      </div>
    `
  }

  // Build header with image if available
  const hasImage = poi && poi.thumbnailPath
  const imageHtml = hasImage
    ? `
    <div class="avatar avatar--fallback">
      <img src="${poi.thumbnailPath}" alt="${name}" />
    </div>
  `
    : ''

  const headerClass = hasImage ? 'map__aside-header map__aside-header--overlap' : 'map__aside-header'

  // Build intro section with styled box (using region color)
  const introBoxClass = regionSlug ? `island island--shadow sign bg--${regionSlug}` : 'island island--shadow sign'
  const introHtml = intro
    ? `
    <div class="${introBoxClass}">
      ${intro}
    </div>
  `
    : ''

  // Build description section
  const descriptionHtml = description ? description : ''

  // Build region info section
  let regionInfoHtml = ''
  if (region && category !== 'Natuurgebied') {
    // Find nature reserves for this POI (simplified - in real data this would come from the POI)
    const natureReserves = []
    // For dummy data, we'll skip nature reserves for now as it requires more complex logic
    // In real implementation, this would come from the POI's NatureReserves relationship

    if (region || natureReserves.length > 0) {
      regionInfoHtml = `
        <div class="map__aside-region-info sign">
          ${
            region
              ? `
            <div class="map__aside-region-info-item">
              <span class="map__aside-region-info-label">Regio:</span>
              <span class="map__aside-region-info-value">${region.name}</span>
            </div>
          `
              : ''
          }
          ${
            natureReserves.length > 0
              ? `
            <div class="map__aside-region-info-item">
              <span class="map__aside-region-info-label">Natuurgebied:</span>
              <span class="map__aside-region-info-value">${natureReserves.map((nr) => nr.name).join(', ')}</span>
            </div>
          `
              : ''
          }
        </div>
      `
    }
  }

  // Build the full HTML matching the real template structure
  return `
    <div class="map__aside-holder">
      ${regionLogoHtml}
      <div class="map__aside-inner">
        <div class="js-tab tab" data-tab-id="aside-info">
          <div class="sign">
            <div class="${headerClass}">
              <div class="heading-s color--brand-ter sign-s">${name}</div>
              ${imageHtml}
            </div>
          </div>
          ${introHtml}
          ${descriptionHtml}
        </div>
        ${regionInfoHtml}
      </div>
    </div>
  `
}

// Intercept fetch calls to inject dummy data
function interceptApiCalls() {
  if (!ENABLE_DUMMY_DATA) return

  const originalFetch = window.fetch

  window.fetch = function (...args) {
    const url = args[0]

    // Check if this is a POI request
    if (typeof url === 'string' && (url.includes('/api/poi') || url.includes('/vrijwilligersgroepen'))) {
      console.log('[Dummy Data] Intercepting POI request:', url)
      // Determine map type the same way as mapApp.js does - by checking the mapSection dataset
      const mapSection = document.querySelector('section.map')
      const isVolunteerGroups = mapSection?.dataset.type === 'VolunteerGroupMapPage'
      const pois = generateDummyPois(300, isVolunteerGroups) // Generate 300 POIs to ensure all categories are represented
      return Promise.resolve({
        ok: true,
        json: () => Promise.resolve(pois),
        text: () => Promise.resolve(JSON.stringify(pois)),
      })
    }

    // Check if this is a regions request
    if (typeof url === 'string' && url.includes('/api/regions')) {
      console.log('[Dummy Data] Intercepting regions request:', url)
      const regions = generateDummyRegions()
      return Promise.resolve({
        ok: true,
        json: () => Promise.resolve(regions),
        text: () => Promise.resolve(JSON.stringify(regions)),
      })
    }

    // Check if this is a markerContent request
    if (typeof url === 'string' && url.includes('/api/markerContent')) {
      console.log('[Dummy Data] Intercepting markerContent request:', url)
      const urlObj = new URL(url, window.location.origin)
      const id = urlObj.searchParams.get('id')
      const type = urlObj.searchParams.get('type')

      let name = `Item ${id}`
      let category = 'Onbekend'
      let poi = null

      // Handle region type
      if (type === 'region') {
        const region = REGION_DATA.find((r) => r.id === parseInt(id, 10))
        if (region) {
          name = region.name
          category = 'Regio'
        }
      } else {
        // Try to find the POI to get its data
        const pois = generateDummyPois(300)
        poi = pois.find((p) => p.id === id)
        if (poi) {
          name = poi.name
          category = poi.category
        }
      }

      // Pass the full POI object to generateMarkerContent so it can use intro and description
      const dummyContent = generateMarkerContent(id, type, name, category, poi)

      return Promise.resolve({
        ok: true,
        text: () => Promise.resolve(dummyContent),
      })
    }

    // For all other requests, use the original fetch
    return originalFetch.apply(this, args)
  }
}

// Initialize dummy data system
export function initDummyData() {
  if (!ENABLE_DUMMY_DATA) {
    console.log('[Dummy Data] Disabled')
    return
  }

  console.log('[Dummy Data] Enabled - Intercepting API calls')
  console.log('[Dummy Data] Will generate ~150 POIs across all categories')
  interceptApiCalls()
}

// Generate dummy region polygons for testing using actual KML coordinates
function createDummyRegionsLayer(regionArr, mapApp) {
  if (!window.L) {
    console.error('[Dummy Data] Leaflet not available')
    return null
  }

  const L = window.L
  const layerGroup = L.layerGroup()

  REGION_DATA.forEach((regionData) => {
    // Find matching region from API data
    const region = regionArr.find((r) => r.id === regionData.id)
    if (!region) return

    // Get actual polygon coordinates from REGION_POLYGONS
    const polygonData = REGION_POLYGONS[regionData.kmlId]
    if (!polygonData || !polygonData.polygons || polygonData.polygons.length === 0) {
      console.warn(`[Dummy Data] No polygon data found for region ${regionData.name}`)
      return
    }

    // Create a polygon for each coordinate array (some regions have multiple polygons)
    polygonData.polygons.forEach((coords) => {
      const polygon = L.polygon(coords, {
        color: polygonData.hexcolor,
        weight: 4,
        stroke: true,
        fillOpacity: 0.2,
        fillColor: polygonData.hexcolor,
      })

      // Add region data to polygon for popup
      polygon.feature = {
        properties: {
          Id: regionData.kmlId,
          Regio: regionData.name,
          Hexcolor: polygonData.hexcolor,
        },
      }

      // Create popup - use createPopup from mapApp if available
      let popupContent
      if (window.createPopup && typeof window.createPopup === 'function') {
        const popupHtml = window.createPopup({
          Title: region.name,
          onButtonClick: () => {
            if (mapApp.asideContainer) {
              mapApp.asideContainer.innerHTML = ''
            }
            mapApp.centerMapOnCurrentRegion(region)
          },
        })
        popupContent = popupHtml
      } else {
        // Simple popup fallback
        popupContent = `
          <div class="popup-content">
            <h2 class="heading-xs color--brand-ter">${region.name}</h2>
          </div>
        `
      }

      const popup = L.popup().setContent(popupContent)
      polygon.bindPopup(popup)

      // Add click handler
      polygon.addEventListener('click', () => {
        if (mapApp.asideContainer) {
          mapApp.asideContainer.innerHTML = ''
        }
        mapApp.setAside(region.id, 'region')
        mapApp.currentRegion = region
        mapApp.currentMarker = false
        mapApp.updateURL()
      })

      layerGroup.addLayer(polygon)
    })
  })

  return layerGroup
}

/**
 * Setup dummy regions layer if dummy data is enabled
 * Returns the layer if created, null otherwise
 * This function handles all dummy data logic internally
 */
export function setupDummyRegionsLayer(regionArr, mapApp, fitBounds = true) {
  if (!ENABLE_DUMMY_DATA) {
    return null
  }

  if (!regionArr || regionArr.length === 0) {
    return null
  }

  console.log('[Dummy Data] Creating dummy region polygons')
  const dummyLayer = createDummyRegionsLayer(regionArr, mapApp)

  if (!dummyLayer) {
    return null
  }

  dummyLayer.addTo(mapApp.map)
  mapApp.regionsKmlLayer = dummyLayer

  if (fitBounds && dummyLayer.getBounds && typeof dummyLayer.getBounds === 'function') {
    try {
      mapApp.map.fitBounds(dummyLayer.getBounds(), { maxZoom: 10 })
    } catch (e) {
      console.warn('[Dummy Data] Could not fit bounds for regions:', e)
    }
  }

  return dummyLayer
}

/**
 * Check if regions data should be fetched (allows dummy mode without KML)
 */
export function shouldFetchRegions(mapSection) {
  // In dummy mode, we can create regions even without KML file
  if (!mapSection.dataset.kmlRegions && !ENABLE_DUMMY_DATA) {
    return false
  }
  return true
}

export { ENABLE_DUMMY_DATA, generateDummyPois, generateDummyRegions }
